var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _rect, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLotB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1634,
    height: 2279,
    viewBox: "0 0 1634 2279",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.344 727.038C155.228 721.21 162.569 704.418 156.74 689.534C150.911 674.65 134.12 667.309 119.236 673.137C104.351 678.966 97.0103 695.758 102.839 710.642C108.668 725.526 125.459 732.867 140.344 727.038Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.623 674.126C105.285 679.741 98.2132 695.916 103.828 710.255C109.443 724.593 125.619 731.665 139.957 726.05C154.295 720.435 161.367 704.259 155.752 689.921C150.137 675.582 133.962 668.511 119.623 674.126ZM101.851 711.029C95.8086 695.599 103.419 678.191 118.849 672.149C134.279 666.106 151.687 673.716 157.729 689.147C163.772 704.577 156.162 721.984 140.731 728.027C125.301 734.069 107.894 726.459 101.851 711.029Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M180.537 829.675C195.421 823.846 202.762 807.055 196.933 792.171C191.105 777.286 174.313 769.945 159.429 775.774C144.545 781.603 137.204 798.394 143.032 813.279C148.861 828.163 165.653 835.504 180.537 829.675Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.815 776.763C145.476 782.378 138.405 798.553 144.02 812.891C149.635 827.23 165.81 834.301 180.148 828.686C194.487 823.071 201.559 806.896 195.944 792.558C190.329 778.219 174.153 771.147 159.815 776.763ZM142.043 813.666C136 798.235 143.61 780.828 159.041 774.785C174.471 768.743 191.878 776.353 197.921 791.783C203.963 807.214 196.353 824.621 180.923 830.663C165.492 836.706 148.085 829.096 142.043 813.666Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M251.086 915.241C265.97 909.413 273.311 892.621 267.482 877.737C261.653 862.853 244.862 855.512 229.978 861.341C215.093 867.169 207.753 883.961 213.581 898.845C219.41 913.729 236.201 921.07 251.086 915.241Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.366 862.329C216.027 867.944 208.955 884.119 214.57 898.458C220.185 912.796 236.361 919.868 250.699 914.253C265.038 908.638 272.109 892.462 266.494 878.124C260.879 863.786 244.704 856.714 230.366 862.329ZM212.593 899.232C206.551 883.802 214.161 866.394 229.591 860.352C245.022 854.309 262.429 861.92 268.471 877.35C274.514 892.78 266.904 910.187 251.473 916.23C236.043 922.272 218.636 914.662 212.593 899.232Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M916.651 274.336L910.455 257.853L912.526 257.075L918.722 273.558L916.651 274.336Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M899.783 265.547L904.97 279.075L886.487 286.161L881.301 272.633L899.783 265.547ZM898.524 268.372L884.125 273.892L887.746 283.336L902.145 277.816L898.524 268.372Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M903.195 270.676L915.548 265.839L916.345 267.875L903.993 272.712L903.195 270.676Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M800.809 727.942L794.389 711.547L796.449 710.74L802.869 727.135L800.809 727.942Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M783.811 719.332L788.997 732.86L770.515 739.946L765.328 726.418L783.811 719.332ZM782.552 722.157L768.153 727.677L771.774 737.121L786.172 731.601L782.552 722.157Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M787.436 724.492L799.788 719.655L800.585 721.691L788.233 726.528L787.436 724.492Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M814.881 763.875L808.461 747.48L810.521 746.674L816.942 763.069L814.881 763.875Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M797.854 755.254L803.04 768.782L784.558 775.868L779.371 762.34L797.854 755.254ZM796.594 758.079L782.196 763.599L785.817 773.043L800.215 767.523L796.594 758.079Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M801.439 760.196L813.88 755.584L814.64 757.634L802.2 762.247L801.439 760.196Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M837.219 820.922L830.799 804.527L832.859 803.72L839.279 820.115L837.219 820.922Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M820.277 812.34L825.464 825.868L806.982 832.954L801.795 819.426L820.277 812.34ZM819.018 815.165L804.62 820.685L808.241 830.129L822.639 824.609L819.018 815.165Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M823.846 817.473L836.198 812.635L836.995 814.672L824.643 819.509L823.846 817.473Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M851.291 856.856L844.871 840.461L846.931 839.654L853.352 856.049L851.291 856.856Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M834.32 848.262L839.507 861.79L821.024 868.876L815.838 855.348L834.32 848.262ZM833.061 851.087L818.663 856.607L822.283 866.051L836.682 860.531L833.061 851.087Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M837.918 853.406L850.27 848.569L851.068 850.605L838.715 855.442L837.918 853.406Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M870.112 904.916L863.779 888.746L865.84 887.939L872.172 904.109L870.112 904.916Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M853.189 896.348L858.376 909.875L839.894 916.962L834.707 903.434L853.189 896.348ZM851.93 899.172L837.532 904.693L841.153 914.137L855.551 908.616L851.93 899.172Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M856.738 901.469L869.091 896.632L869.888 898.668L857.536 903.505L856.738 901.469Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M884.184 940.852L877.764 924.457L879.824 923.65L886.244 940.045L884.184 940.852Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M867.232 932.27L872.419 945.797L853.937 952.884L848.75 939.356L867.232 932.27ZM865.973 935.094L851.575 940.615L855.196 950.059L869.594 944.538L865.973 935.094Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M870.812 937.402L883.165 932.565L883.962 934.601L871.61 939.439L870.812 937.402Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M903.709 990.711L897.289 974.316L899.349 973.51L905.77 989.904L903.709 990.711Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M886.6 982.059L891.786 995.586L873.304 1002.67L868.117 989.145L886.6 982.059ZM885.341 984.883L870.942 990.404L874.563 999.848L888.962 994.327L885.341 984.883Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M890.267 987.032L902.708 982.42L903.468 984.47L891.028 989.083L890.267 987.032Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M917.782 1026.64L911.361 1010.25L913.422 1009.44L919.842 1025.84L917.782 1026.64Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M900.869 1017.89L906.056 1031.42L887.573 1038.51L882.387 1024.98L900.869 1017.89ZM899.61 1020.72L885.211 1026.24L888.832 1035.68L903.231 1030.16L899.61 1020.72Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M904.32 1022.97L916.673 1018.14L917.47 1020.17L905.118 1025.01L904.32 1022.97Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M939.946 1083.24L933.525 1066.84L935.586 1066.04L942.006 1082.43L939.946 1083.24Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M922.924 1074.63L928.111 1088.16L909.628 1095.24L904.441 1081.72L922.924 1074.63ZM921.665 1077.45L907.266 1082.97L910.887 1092.42L925.286 1086.9L921.665 1077.45Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M926.502 1079.56L938.942 1074.95L939.702 1077L927.262 1081.61L926.502 1079.56Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M954.018 1119.17L947.598 1102.78L949.658 1101.97L956.078 1118.37L954.018 1119.17Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M936.967 1110.55L942.154 1124.08L923.671 1131.16L918.484 1117.64L936.967 1110.55ZM935.708 1113.38L921.309 1118.9L924.93 1128.34L939.329 1122.82L935.708 1113.38Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M940.576 1115.49L953.016 1110.88L953.777 1112.93L941.336 1117.54L940.576 1115.49Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M973.453 1168.81L967.121 1152.64L969.181 1151.83L975.514 1168L973.453 1168.81Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M956.561 1160.25L961.747 1173.78L943.265 1180.87L938.078 1167.34L956.561 1160.25ZM955.302 1163.08L940.903 1168.6L944.524 1178.04L958.922 1172.52L955.302 1163.08Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M960.082 1165.36L972.434 1160.52L973.232 1162.56L960.879 1167.4L960.082 1165.36Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M987.526 1204.74L981.193 1188.57L983.254 1187.76L989.586 1203.93L987.526 1204.74Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M970.604 1196.18L975.79 1209.7L957.308 1216.79L952.121 1203.26L970.604 1196.18ZM969.344 1199L954.946 1204.52L958.567 1213.97L972.965 1208.44L969.344 1199Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M974.154 1201.29L986.507 1196.46L987.304 1198.49L974.952 1203.33L974.154 1201.29Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1010.83 1264.26L1004.5 1248.09L1006.56 1247.28L1012.89 1263.45L1010.83 1264.26Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M993.938 1255.71L999.124 1269.23L980.642 1276.32L975.455 1262.79L993.938 1255.71ZM992.678 1258.53L978.28 1264.05L981.901 1273.5L996.299 1267.98L992.678 1258.53Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M997.459 1260.81L1009.81 1255.97L1010.61 1258.01L998.256 1262.84L997.459 1260.81Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1024.9 1300.19L1018.57 1284.02L1020.63 1283.21L1026.97 1299.38L1024.9 1300.19Z",
    fill: "#9C9C9C"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1007.98 1291.62L1013.17 1305.15L994.685 1312.24L989.498 1298.71L1007.98 1291.62ZM1006.72 1294.45L992.323 1299.97L995.944 1309.41L1010.34 1303.89L1006.72 1294.45Z",
    fill: "#9C9C9C"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1011.53 1296.74L1023.88 1291.9L1024.68 1293.94L1012.33 1298.78L1011.53 1296.74Z",
    fill: "#9C9C9C"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1044.43 1350.05L1038.01 1333.66L1040.07 1332.85L1046.49 1349.24L1044.43 1350.05Z",
    fill: "#9C9C9C"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1027.35 1341.42L1032.54 1354.95L1014.05 1362.03L1008.87 1348.5L1027.35 1341.42ZM1026.09 1344.24L1011.69 1349.76L1015.31 1359.21L1029.71 1353.69L1026.09 1344.24Z",
    fill: "#9C9C9C"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1030.99 1346.37L1043.43 1341.76L1044.19 1343.81L1031.75 1348.42L1030.99 1346.37Z",
    fill: "#9C9C9C"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1058.5 1385.98L1052.08 1369.59L1054.14 1368.78L1060.56 1385.18L1058.5 1385.98Z",
    fill: "#9C9C9C"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1041.39 1377.34L1046.58 1390.87L1028.1 1397.95L1022.91 1384.43L1041.39 1377.34ZM1040.13 1380.16L1025.73 1385.69L1029.36 1395.13L1043.75 1389.61L1040.13 1380.16Z",
    fill: "#9C9C9C"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1045.06 1382.3L1057.5 1377.69L1058.26 1379.74L1045.82 1384.35L1045.06 1382.3Z",
    fill: "#9C9C9C"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1080.31 1441.68L1073.98 1425.51L1076.04 1424.7L1082.37 1440.87L1080.31 1441.68Z",
    fill: "#9C9C9C"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1063.44 1433.14L1068.62 1446.67L1050.14 1453.75L1044.95 1440.23L1063.44 1433.14ZM1062.18 1435.97L1047.78 1441.49L1051.4 1450.93L1065.8 1445.41L1062.18 1435.97Z",
    fill: "#9C9C9C"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1066.94 1438.23L1079.29 1433.39L1080.09 1435.43L1067.74 1440.27L1066.94 1438.23Z",
    fill: "#9C9C9C"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1094.39 1477.61L1088.05 1461.44L1090.11 1460.63L1096.45 1476.8L1094.39 1477.61Z",
    fill: "#9C9C9C"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1077.48 1469.06L1082.67 1482.59L1064.18 1489.67L1059 1476.14L1077.48 1469.06ZM1076.22 1471.88L1061.82 1477.4L1065.44 1486.85L1079.84 1481.33L1076.22 1471.88Z",
    fill: "#9C9C9C"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1081.01 1474.16L1093.37 1469.33L1094.16 1471.36L1081.81 1476.2L1081.01 1474.16Z",
    fill: "#9C9C9C"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1113.91 1527.47L1107.49 1511.08L1109.55 1510.27L1115.97 1526.67L1113.91 1527.47Z",
    fill: "#9C9C9C"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1096.85 1518.85L1102.03 1532.38L1083.55 1539.47L1078.36 1525.94L1096.85 1518.85ZM1095.59 1521.68L1081.19 1527.2L1084.81 1536.64L1099.21 1531.12L1095.59 1521.68Z",
    fill: "#9C9C9C"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1100.47 1523.79L1112.91 1519.18L1113.67 1521.23L1101.23 1525.84L1100.47 1523.79Z",
    fill: "#9C9C9C"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1127.98 1563.41L1121.56 1547.01L1123.62 1546.2L1130.04 1562.6L1127.98 1563.41Z",
    fill: "#9C9C9C"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1110.89 1554.77L1116.08 1568.3L1097.59 1575.39L1092.41 1561.86L1110.89 1554.77ZM1109.63 1557.6L1095.23 1563.12L1098.85 1572.56L1113.25 1567.04L1109.63 1557.6Z",
    fill: "#9C9C9C"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1114.54 1559.72L1126.98 1555.11L1127.74 1557.16L1115.3 1561.77L1114.54 1559.72Z",
    fill: "#9C9C9C"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1149.44 1618.21L1143.02 1601.81L1145.08 1601.01L1151.5 1617.4L1149.44 1618.21Z",
    fill: "#9C9C9C"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1132.41 1609.61L1137.6 1623.13L1119.12 1630.22L1113.93 1616.69L1132.41 1609.61ZM1131.15 1612.43L1116.75 1617.95L1120.38 1627.39L1134.77 1621.87L1131.15 1612.43Z",
    fill: "#9C9C9C"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1136 1614.53L1148.44 1609.92L1149.2 1611.97L1136.76 1616.58L1136 1614.53Z",
    fill: "#9C9C9C"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1163.51 1654.14L1157.09 1637.75L1159.15 1636.94L1165.57 1653.33L1163.51 1654.14Z",
    fill: "#9C9C9C"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1146.46 1645.53L1151.64 1659.06L1133.16 1666.14L1127.97 1652.61L1146.46 1645.53ZM1145.2 1648.35L1130.8 1653.87L1134.42 1663.32L1148.82 1657.8L1145.2 1648.35Z",
    fill: "#9C9C9C"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1150.07 1650.46L1162.51 1645.85L1163.27 1647.9L1150.83 1652.51L1150.07 1650.46Z",
    fill: "#9C9C9C"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1187.08 1714.33L1180.75 1698.16L1182.81 1697.35L1189.14 1713.52L1187.08 1714.33Z",
    fill: "#9C9C9C"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1170.23 1705.8L1175.41 1719.33L1156.93 1726.42L1151.74 1712.89L1170.23 1705.8ZM1168.97 1708.63L1154.57 1714.15L1158.19 1723.59L1172.59 1718.07L1168.97 1708.63Z",
    fill: "#9C9C9C"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1173.71 1710.88L1186.06 1706.04L1186.86 1708.08L1174.51 1712.92L1173.71 1710.88Z",
    fill: "#9C9C9C"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M838.09 713.344L831.67 696.949L833.73 696.142L840.151 712.537L838.09 713.344Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M864.988 687.355L870.367 700.808L851.988 708.157L846.609 694.705L864.988 687.355ZM863.77 690.198L849.451 695.923L853.206 705.315L867.525 699.589L863.77 690.198Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M848.423 702.961L836.071 707.798L835.273 705.762L847.626 700.924L848.423 702.961Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M852.163 749.278L845.742 732.883L847.803 732.076L854.223 748.471L852.163 749.278Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M879.031 723.277L884.41 736.73L866.031 744.079L860.652 730.626L879.031 723.277ZM877.813 726.12L863.494 731.845L867.249 741.236L881.568 735.511L877.813 726.12Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M862.425 738.661L850.161 743.723L849.326 741.701L861.591 736.639L862.425 738.661Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M874.502 806.325L868.082 789.93L870.142 789.123L876.563 805.518L874.502 806.325Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M901.455 780.363L906.834 793.816L888.454 801.165L883.075 787.712L901.455 780.363ZM900.236 783.206L885.918 788.931L889.673 798.322L903.992 792.597L900.236 783.206Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M884.835 795.941L872.483 800.778L871.686 798.742L884.038 793.905L884.835 795.941Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M888.575 842.258L882.154 825.863L884.215 825.056L890.635 841.451L888.575 842.258Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M915.498 816.285L920.877 829.738L902.497 837.087L897.118 823.634L915.498 816.285ZM914.279 819.128L899.961 824.853L903.716 834.244L918.035 828.519L914.279 819.128Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M898.908 831.875L886.555 836.712L885.758 834.676L898.11 829.839L898.908 831.875Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M907.395 890.319L901.062 874.148L903.123 873.342L909.455 889.512L907.395 890.319Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M934.367 864.367L939.746 877.82L921.366 885.169L915.987 871.716L934.367 864.367ZM933.149 867.21L918.83 872.935L922.585 882.326L936.904 876.601L933.149 867.21Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M917.728 879.933L905.376 884.771L904.578 882.734L916.93 877.897L917.728 879.933Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M921.467 926.254L915.047 909.859L917.107 909.053L923.528 925.447L921.467 926.254Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M948.41 900.289L953.789 913.742L935.409 921.091L930.03 907.638L948.41 900.289ZM947.192 903.132L932.873 908.857L936.628 918.248L950.947 912.523L947.192 903.132Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M931.8 915.871L919.448 920.708L918.65 918.672L931.003 913.835L931.8 915.871Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M940.991 976.11L934.57 959.715L936.631 958.908L943.051 975.303L940.991 976.11Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M967.777 950.078L973.156 963.531L954.777 970.88L949.398 957.427L967.777 950.078ZM966.559 952.921L952.24 958.646L955.995 968.037L970.314 962.312L966.559 952.921Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M951.253 965.493L938.989 970.555L938.154 968.533L950.419 963.471L951.253 965.493Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M955.063 1012.04L948.643 995.648L950.703 994.842L957.123 1011.24L955.063 1012.04Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M982.045 985.91L987.424 999.363L969.044 1006.71L963.665 993.259L982.045 985.91ZM980.826 988.753L966.508 994.478L970.263 1003.87L984.581 998.144L980.826 988.753Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M965.308 1001.43L952.956 1006.27L952.158 1004.23L964.51 999.397L965.308 1001.43Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M977.227 1068.64L970.807 1052.25L972.867 1051.44L979.287 1067.83L977.227 1068.64Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1004.1 1042.65L1009.48 1056.1L991.101 1063.45L985.722 1050L1004.1 1042.65ZM1002.88 1045.49L988.564 1051.22L992.32 1060.61L1006.64 1054.89L1002.88 1045.49Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M987.489 1058.02L975.225 1063.09L974.391 1061.06L986.655 1056L987.489 1058.02Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M991.299 1104.57L984.879 1088.18L986.939 1087.37L993.36 1103.77L991.299 1104.57Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1018.14 1078.57L1023.52 1092.02L1005.14 1099.37L999.765 1085.92L1018.14 1078.57ZM1016.93 1081.41L1002.61 1087.14L1006.36 1096.53L1020.68 1090.8L1016.93 1081.41Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1001.56 1093.96L989.297 1099.02L988.463 1097L1000.73 1091.94L1001.56 1093.96Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1010.73 1154.21L1004.4 1138.04L1006.46 1137.23L1012.8 1153.4L1010.73 1154.21Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1037.74 1128.28L1043.12 1141.73L1024.74 1149.08L1019.36 1135.63L1037.74 1128.28ZM1036.52 1131.12L1022.2 1136.85L1025.95 1146.24L1040.27 1140.51L1036.52 1131.12Z",
    fill: "#9C9C9C"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1021.07 1143.82L1008.72 1148.66L1007.92 1146.62L1020.27 1141.79L1021.07 1143.82Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1024.81 1190.14L1018.47 1173.97L1020.53 1173.17L1026.87 1189.34L1024.81 1190.14Z",
    fill: "#9C9C9C"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1051.78 1164.2L1057.16 1177.65L1038.78 1185L1033.4 1171.54L1051.78 1164.2ZM1050.56 1167.04L1036.24 1172.76L1040 1182.15L1054.32 1176.43L1050.56 1167.04Z",
    fill: "#9C9C9C"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1035.14 1179.76L1022.79 1184.59L1021.99 1182.56L1034.34 1177.72L1035.14 1179.76Z",
    fill: "#9C9C9C"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1048.11 1249.66L1041.78 1233.49L1043.84 1232.68L1050.17 1248.85L1048.11 1249.66Z",
    fill: "#9C9C9C"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1075.12 1223.73L1080.49 1237.18L1062.11 1244.53L1056.74 1231.08L1075.12 1223.73ZM1073.9 1226.57L1059.58 1232.29L1063.33 1241.69L1077.65 1235.96L1073.9 1226.57Z",
    fill: "#9C9C9C"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1058.45 1239.27L1046.09 1244.11L1045.3 1242.07L1057.65 1237.24L1058.45 1239.27Z",
    fill: "#9C9C9C"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1062.19 1285.59L1055.85 1269.42L1057.91 1268.62L1064.25 1284.79L1062.19 1285.59Z",
    fill: "#9C9C9C"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1089.16 1259.65L1094.54 1273.1L1076.16 1280.45L1070.78 1267L1089.16 1259.65ZM1087.94 1262.49L1073.62 1268.22L1077.38 1277.61L1091.69 1271.88L1087.94 1262.49Z",
    fill: "#9C9C9C"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1072.52 1275.21L1060.17 1280.04L1059.37 1278.01L1071.72 1273.17L1072.52 1275.21Z",
    fill: "#9C9C9C"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1081.71 1335.45L1075.29 1319.05L1077.35 1318.25L1083.77 1334.64L1081.71 1335.45Z",
    fill: "#9C9C9C"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1108.53 1309.44L1113.91 1322.89L1095.53 1330.24L1090.15 1316.79L1108.53 1309.44ZM1107.31 1312.28L1092.99 1318.01L1096.75 1327.4L1111.06 1321.67L1107.31 1312.28Z",
    fill: "#9C9C9C"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1091.97 1324.83L1079.71 1329.89L1078.88 1327.87L1091.14 1322.81L1091.97 1324.83Z",
    fill: "#9C9C9C"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1095.78 1371.38L1089.36 1354.99L1091.42 1354.18L1097.84 1370.58L1095.78 1371.38Z",
    fill: "#9C9C9C"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1122.57 1345.36L1127.95 1358.81L1109.57 1366.16L1104.19 1352.71L1122.57 1345.36ZM1121.35 1348.2L1107.03 1353.93L1110.79 1363.32L1125.11 1357.59L1121.35 1348.2Z",
    fill: "#9C9C9C"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1106.05 1360.77L1093.78 1365.83L1092.95 1363.81L1105.21 1358.74L1106.05 1360.77Z",
    fill: "#9C9C9C"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1117.59 1427.08L1111.26 1410.91L1113.32 1410.1L1119.65 1426.27L1117.59 1427.08Z",
    fill: "#9C9C9C"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1144.61 1401.16L1149.99 1414.61L1131.61 1421.96L1126.23 1408.51L1144.61 1401.16ZM1143.39 1404L1129.08 1409.73L1132.83 1419.12L1147.15 1413.39L1143.39 1404Z",
    fill: "#9C9C9C"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1127.93 1416.7L1115.57 1421.53L1114.78 1419.5L1127.13 1414.66L1127.93 1416.7Z",
    fill: "#9C9C9C"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1131.67 1463.01L1125.33 1446.84L1127.39 1446.04L1133.73 1462.21L1131.67 1463.01Z",
    fill: "#9C9C9C"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1158.65 1437.08L1164.03 1450.53L1145.65 1457.88L1140.27 1444.43L1158.65 1437.08ZM1157.44 1439.92L1143.12 1445.65L1146.87 1455.04L1161.19 1449.32L1157.44 1439.92Z",
    fill: "#9C9C9C"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1142 1452.63L1129.65 1457.47L1128.85 1455.43L1141.2 1450.59L1142 1452.63Z",
    fill: "#9C9C9C"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1151.19 1512.88L1144.77 1496.48L1146.83 1495.67L1153.25 1512.07L1151.19 1512.88Z",
    fill: "#9C9C9C"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1178.03 1486.88L1183.4 1500.33L1165.02 1507.68L1159.65 1494.22L1178.03 1486.88ZM1176.81 1489.72L1162.49 1495.44L1166.24 1504.83L1180.56 1499.11L1176.81 1489.72Z",
    fill: "#9C9C9C"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1161.45 1502.26L1149.19 1507.32L1148.36 1505.3L1160.62 1500.24L1161.45 1502.26Z",
    fill: "#9C9C9C"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1165.26 1548.81L1158.84 1532.41L1160.9 1531.61L1167.32 1548L1165.26 1548.81Z",
    fill: "#9C9C9C"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1192.07 1522.8L1197.45 1536.25L1179.07 1543.6L1173.69 1530.15L1192.07 1522.8ZM1190.85 1525.64L1176.53 1531.36L1180.29 1540.76L1194.6 1535.03L1190.85 1525.64Z",
    fill: "#9C9C9C"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1175.53 1538.19L1163.26 1543.25L1162.43 1541.23L1174.69 1536.17L1175.53 1538.19Z",
    fill: "#9C9C9C"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1186.72 1603.61L1180.3 1587.21L1182.36 1586.4L1188.78 1602.8L1186.72 1603.61Z",
    fill: "#9C9C9C"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1213.59 1577.62L1218.97 1591.07L1200.59 1598.42L1195.21 1584.97L1213.59 1577.62ZM1212.37 1580.46L1198.05 1586.19L1201.81 1595.58L1216.13 1589.85L1212.37 1580.46Z",
    fill: "#9C9C9C"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1196.99 1592.99L1184.72 1598.05L1183.89 1596.03L1196.15 1590.97L1196.99 1592.99Z",
    fill: "#9C9C9C"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1200.8 1639.54L1194.38 1623.14L1196.44 1622.34L1202.86 1638.73L1200.8 1639.54Z",
    fill: "#9C9C9C"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1227.63 1613.54L1233.01 1627L1214.63 1634.34L1209.25 1620.89L1227.63 1613.54ZM1226.41 1616.39L1212.1 1622.11L1215.85 1631.5L1230.17 1625.78L1226.41 1616.39Z",
    fill: "#9C9C9C"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1211.06 1628.92L1198.79 1633.98L1197.96 1631.96L1210.22 1626.9L1211.06 1628.92Z",
    fill: "#9C9C9C"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1224.37 1699.73L1218.03 1683.56L1220.09 1682.75L1226.43 1698.92L1224.37 1699.73Z",
    fill: "#9C9C9C"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1251.4 1673.82L1256.78 1687.28L1238.4 1694.63L1233.02 1681.17L1251.4 1673.82ZM1250.19 1676.67L1235.87 1682.39L1239.62 1691.78L1253.94 1686.06L1250.19 1676.67Z",
    fill: "#9C9C9C"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1234.7 1689.34L1222.35 1694.18L1221.55 1692.14L1233.9 1687.31L1234.7 1689.34Z",
    fill: "#9C9C9C"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M548.028 1000.12L696.285 944.133L697.035 946.12L548.778 1002.11L548.028 1000.12Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.484 1034.48L709.653 978.273L710.406 980.258L562.237 1036.47L561.484 1034.48Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M822.695 1701.5L970.864 1645.29L971.617 1647.28L823.448 1703.49L822.695 1701.5Z",
    fill: "#9C9C9C"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M836.062 1735.64L984.231 1679.43L984.984 1681.42L836.815 1737.63L836.062 1735.64Z",
    fill: "#9C9C9C"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M810.91 1671.41L959.079 1615.2L959.832 1617.18L811.663 1673.39L810.91 1671.41Z",
    fill: "#9C9C9C"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M902.377 1904.98L1050.55 1848.77L1051.3 1850.75L903.13 1906.97L902.377 1904.98Z",
    fill: "#9C9C9C"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M949.054 1579.7L794.353 1641.06L793.57 1639.09L948.272 1577.73L949.054 1579.7Z",
    fill: "#9C9C9C"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M845.979 1316.49L691.366 1378.07L690.58 1376.1L845.194 1314.51L845.979 1316.49Z",
    fill: "#9C9C9C"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M578.611 633.741L423.91 695.1L423.127 693.127L577.828 631.768L578.611 633.741Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M463.567 1299.04L537.173 1272.03L537.687 1273.43L464.081 1300.44L463.567 1299.04Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M476.937 1333.17L550.631 1306.39L551.14 1307.79L477.446 1334.58L476.937 1333.17Z",
    fill: "#9C9C9C"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M490.042 1366.64L563.736 1339.85L564.246 1341.25L490.551 1368.04L490.042 1366.64Z",
    fill: "#9C9C9C"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.784 1268.94L525.479 1242.16L525.988 1243.56L452.294 1270.35L451.784 1268.94Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.338 1206.55L437.105 1237.44L436.545 1236.06L512.778 1205.17L513.338 1206.55Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.166 1178.03L425.845 1208.69L425.289 1207.31L501.61 1176.64L502.166 1178.03Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M411.679 1166.53L485.373 1139.74L485.883 1141.14L412.188 1167.93L411.679 1166.53Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.275 976.573L346.955 1007.24L346.399 1005.85L422.719 975.189L423.275 976.573Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M648.085 1770.22L721.691 1743.21L722.205 1744.61L648.598 1771.62L648.085 1770.22Z",
    fill: "#9C9C9C"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M661.454 1804.36L735.06 1777.35L735.574 1778.75L661.968 1805.76L661.454 1804.36Z",
    fill: "#9C9C9C"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M674.557 1837.82L748.164 1810.81L748.677 1812.21L675.071 1839.22L674.557 1837.82Z",
    fill: "#9C9C9C"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M636.299 1740.13L709.906 1713.12L710.42 1714.52L636.813 1741.53L636.299 1740.13Z",
    fill: "#9C9C9C"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M701.208 1905.87L774.902 1879.08L775.412 1880.48L701.717 1907.27L701.208 1905.87Z",
    fill: "#9C9C9C"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M714.663 1940.23L788.269 1913.22L788.783 1914.62L715.177 1941.63L714.663 1940.23Z",
    fill: "#9C9C9C"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M689.508 1876L763.115 1848.99L763.629 1850.39L690.022 1877.4L689.508 1876Z",
    fill: "#9C9C9C"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M557.936 1540.02L631.543 1513.01L632.056 1514.41L558.45 1541.42L557.936 1540.02Z",
    fill: "#9C9C9C"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M571.393 1574.38L645 1547.37L645.513 1548.77L571.907 1575.78L571.393 1574.38Z",
    fill: "#9C9C9C"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M546.239 1510.15L619.845 1483.14L620.359 1484.54L546.753 1511.55L546.239 1510.15Z",
    fill: "#9C9C9C"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.41 731.772L251.089 762.437L250.533 761.053L326.854 730.388L327.41 731.772Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.48 698.76L238.16 729.425L237.604 728.041L313.924 697.376L314.48 698.76Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M361.398 523.546L509.567 467.336L510.32 469.321L362.151 525.532L361.398 523.546Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.502 557.007L522.671 500.797L523.424 502.782L375.255 558.993L374.502 557.007Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M754.195 759.304L902.589 703.005L903.342 704.991L754.948 761.289L754.195 759.304Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M788.672 847.342L937.154 791.268L937.904 793.254L789.423 849.328L788.672 847.342Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M823.236 935.605L971.63 879.306L972.383 881.291L823.989 937.59L823.236 935.605Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M857.712 1023.64L1006.11 967.341L1006.86 969.327L858.466 1025.63L857.712 1023.64Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M892.893 1113.48L1041.38 1057.4L1042.13 1059.39L893.643 1115.47L892.893 1113.48Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M927.457 1201.74L1075.85 1145.44L1076.6 1147.43L928.21 1203.73L927.457 1201.74Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M962.636 1291.57L1111.03 1235.28L1111.78 1237.26L963.389 1293.56L962.636 1291.57Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M997.201 1379.84L1145.59 1323.54L1146.35 1325.52L997.954 1381.82L997.201 1379.84Z",
    fill: "#9C9C9C"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1030.18 1464.06L1178.66 1407.98L1179.41 1409.97L1030.93 1466.04L1030.18 1464.06Z",
    fill: "#9C9C9C"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1065.45 1554.12L1213.84 1497.82L1214.6 1499.8L1066.2 1556.1L1065.45 1554.12Z",
    fill: "#9C9C9C"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1100.63 1643.95L1249.11 1587.88L1249.86 1589.86L1101.38 1645.94L1100.63 1643.95Z",
    fill: "#9C9C9C"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1138.8 1741.42L1287.19 1685.12L1287.95 1687.11L1139.55 1743.41L1138.8 1741.42Z",
    fill: "#9C9C9C"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M307.722 1010.92C322.607 1005.09 329.948 988.301 324.119 973.417C318.29 958.532 301.499 951.191 286.615 957.02C271.73 962.849 264.389 979.64 270.218 994.525C276.047 1009.41 292.838 1016.75 307.722 1010.92Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.002 958.009C272.664 963.624 265.592 979.799 271.207 994.137C276.822 1008.48 292.998 1015.55 307.336 1009.93C321.674 1004.32 328.746 988.142 323.131 973.804C317.516 959.465 301.341 952.394 287.002 958.009ZM269.23 994.912C263.188 979.481 270.798 962.074 286.228 956.032C301.658 949.989 319.065 957.599 325.108 973.029C331.151 988.46 323.54 1005.87 308.11 1011.91C292.68 1017.95 275.273 1010.34 269.23 994.912Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M351.576 1109.01C366.46 1103.19 373.801 1086.39 367.972 1071.51C362.144 1056.63 345.352 1049.29 330.468 1055.11C315.584 1060.94 308.243 1077.73 314.072 1092.62C319.9 1107.5 336.692 1114.84 351.576 1109.01Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.856 1056.1C316.517 1061.72 309.446 1077.89 315.061 1092.23C320.676 1106.57 336.851 1113.64 351.189 1108.03C365.528 1102.41 372.6 1086.24 366.985 1071.9C361.37 1057.56 345.194 1050.49 330.856 1056.1ZM313.084 1093.01C307.041 1077.58 314.651 1060.17 330.082 1054.13C345.512 1048.08 362.919 1055.69 368.962 1071.12C375.004 1086.55 367.394 1103.96 351.964 1110C336.533 1116.05 319.126 1108.44 313.084 1093.01Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M389.765 1203.89C404.65 1198.06 411.991 1181.27 406.162 1166.39C400.333 1151.5 383.542 1144.16 368.657 1149.99C353.773 1155.82 346.432 1172.61 352.261 1187.49C358.09 1202.38 374.881 1209.72 389.765 1203.89Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.045 1150.98C354.707 1156.59 347.635 1172.77 353.25 1187.11C358.865 1201.44 375.041 1208.52 389.379 1202.9C403.717 1197.29 410.789 1181.11 405.174 1166.77C399.559 1152.43 383.384 1145.36 369.045 1150.98ZM351.273 1187.88C345.231 1172.45 352.841 1155.04 368.271 1149C383.701 1142.96 401.108 1150.57 407.151 1166C413.194 1181.43 405.583 1198.84 390.153 1204.88C374.723 1210.92 357.316 1203.31 351.273 1187.88Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M431.453 1310.34C446.337 1304.51 453.678 1287.72 447.849 1272.84C442.021 1257.95 425.229 1250.61 410.345 1256.44C395.461 1262.27 388.12 1279.06 393.948 1293.95C399.777 1308.83 416.569 1316.17 431.453 1310.34Z",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M410.733 1257.43C396.394 1263.05 389.323 1279.22 394.938 1293.56C400.553 1307.9 416.728 1314.97 431.066 1309.35C445.405 1303.74 452.476 1287.56 446.861 1273.23C441.246 1258.89 425.071 1251.82 410.733 1257.43ZM392.961 1294.33C386.918 1278.9 394.528 1261.5 409.958 1255.45C425.389 1249.41 442.796 1257.02 448.838 1272.45C454.881 1287.88 447.271 1305.29 431.841 1311.33C416.41 1317.37 399.003 1309.76 392.961 1294.33Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M473.845 1418.59C488.73 1412.76 496.071 1395.97 490.242 1381.09C484.413 1366.2 467.622 1358.86 452.738 1364.69C437.853 1370.52 430.512 1387.31 436.341 1402.2C442.17 1417.08 458.961 1424.42 473.845 1418.59Z",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M453.123 1365.68C438.785 1371.3 431.713 1387.47 437.328 1401.81C442.943 1416.15 459.119 1423.22 473.457 1417.6C487.795 1411.99 494.867 1395.81 489.252 1381.48C483.637 1367.14 467.462 1360.07 453.123 1365.68ZM435.351 1402.58C429.309 1387.15 436.919 1369.75 452.349 1363.7C467.779 1357.66 485.187 1365.27 491.229 1380.7C497.272 1396.13 489.662 1413.54 474.231 1419.58C458.801 1425.62 441.394 1418.01 435.351 1402.58Z",
    fill: "#9C9C9C"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M507.265 1503.94C522.15 1498.11 529.491 1481.32 523.662 1466.43C517.833 1451.55 501.042 1444.21 486.157 1450.04C471.273 1455.86 463.932 1472.66 469.761 1487.54C475.59 1502.42 492.381 1509.77 507.265 1503.94Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M486.545 1451.02C472.207 1456.64 465.135 1472.81 470.75 1487.15C476.365 1501.49 492.541 1508.56 506.879 1502.95C521.217 1497.33 528.289 1481.16 522.674 1466.82C517.059 1452.48 500.884 1445.41 486.545 1451.02ZM468.773 1487.93C462.731 1472.5 470.341 1455.09 485.771 1449.05C501.201 1443 518.608 1450.61 524.651 1466.05C530.694 1481.48 523.083 1498.88 507.653 1504.93C492.223 1510.97 474.816 1503.36 468.773 1487.93Z",
    fill: "#9C9C9C"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M590.73 1717.07C605.615 1711.24 612.956 1694.45 607.127 1679.57C601.298 1664.68 584.507 1657.34 569.622 1663.17C554.738 1669 547.397 1685.79 553.226 1700.67C559.055 1715.56 575.846 1722.9 590.73 1717.07Z",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M570.01 1664.16C555.672 1669.77 548.6 1685.95 554.215 1700.29C559.83 1714.62 576.005 1721.7 590.344 1716.08C604.682 1710.47 611.754 1694.29 606.139 1679.95C600.524 1665.61 584.348 1658.54 570.01 1664.16ZM552.238 1701.06C546.195 1685.63 553.806 1668.22 569.236 1662.18C584.666 1656.14 602.073 1663.75 608.116 1679.18C614.158 1694.61 606.548 1712.02 591.118 1718.06C575.688 1724.1 558.281 1716.49 552.238 1701.06Z",
    fill: "#9C9C9C"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M630.748 1819.26C645.632 1813.43 652.973 1796.64 647.144 1781.75C641.316 1766.87 624.524 1759.53 609.64 1765.36C594.756 1771.18 587.415 1787.98 593.243 1802.86C599.072 1817.74 615.864 1825.09 630.748 1819.26Z",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M610.028 1766.34C595.689 1771.96 588.618 1788.13 594.233 1802.47C599.848 1816.81 616.023 1823.88 630.361 1818.27C644.7 1812.65 651.771 1796.48 646.156 1782.14C640.541 1767.8 624.366 1760.73 610.028 1766.34ZM592.256 1803.25C586.213 1787.82 593.823 1770.41 609.253 1764.37C624.684 1758.32 642.091 1765.94 648.133 1781.37C654.176 1796.8 646.566 1814.2 631.136 1820.25C615.705 1826.29 598.298 1818.68 592.256 1803.25Z",
    fill: "#9C9C9C"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M670.939 1921.89C685.824 1916.06 693.165 1899.27 687.336 1884.39C681.507 1869.51 664.716 1862.16 649.831 1867.99C634.947 1873.82 627.606 1890.61 633.435 1905.5C639.264 1920.38 656.055 1927.72 670.939 1921.89Z",
    fill: "white"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M650.219 1868.98C635.881 1874.6 628.809 1890.77 634.424 1905.11C640.039 1919.45 656.214 1926.52 670.553 1920.91C684.891 1915.29 691.963 1899.11 686.348 1884.78C680.733 1870.44 664.557 1863.37 650.219 1868.98ZM632.447 1905.88C626.404 1890.45 634.015 1873.05 649.445 1867C664.875 1860.96 682.282 1868.57 688.325 1884C694.367 1899.43 686.757 1916.84 671.327 1922.88C655.897 1928.92 638.49 1921.31 632.447 1905.88Z",
    fill: "#9C9C9C"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M709.726 2020.94C724.611 2015.11 731.952 1998.32 726.123 1983.43C720.294 1968.55 703.503 1961.21 688.618 1967.04C673.734 1972.86 666.393 1989.66 672.222 2004.54C678.051 2019.42 694.842 2026.77 709.726 2020.94Z",
    fill: "white"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M689.006 1968.02C674.668 1973.64 667.596 1989.81 673.211 2004.15C678.826 2018.49 695.001 2025.56 709.34 2019.95C723.678 2014.33 730.75 1998.16 725.135 1983.82C719.52 1969.48 703.345 1962.41 689.006 1968.02ZM671.234 2004.93C665.191 1989.5 672.802 1972.09 688.232 1966.05C703.662 1960 721.069 1967.61 727.112 1983.05C733.155 1998.48 725.544 2015.88 710.114 2021.93C694.684 2027.97 677.277 2020.36 671.234 2004.93Z",
    fill: "#9C9C9C"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M749.744 2123.12C764.628 2117.3 771.969 2100.5 766.14 2085.62C760.312 2070.74 743.52 2063.39 728.636 2069.22C713.752 2075.05 706.411 2091.84 712.24 2106.73C718.068 2121.61 734.86 2128.95 749.744 2123.12Z",
    fill: "white"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M729.022 2070.21C714.683 2075.83 707.612 2092 713.227 2106.34C718.842 2120.68 735.017 2127.75 749.355 2122.14C763.694 2116.52 770.766 2100.35 765.151 2086.01C759.536 2071.67 743.36 2064.6 729.022 2070.21ZM711.25 2107.11C705.207 2091.68 712.817 2074.28 728.248 2068.23C743.678 2062.19 761.085 2069.8 767.128 2085.23C773.17 2100.66 765.56 2118.07 750.13 2124.11C734.699 2130.16 717.292 2122.54 711.25 2107.11Z",
    fill: "#9C9C9C"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M850.74 2123.72C865.624 2117.89 872.965 2101.1 867.136 2086.22C861.308 2071.33 844.516 2063.99 829.632 2069.82C814.748 2075.65 807.407 2092.44 813.236 2107.33C819.064 2122.21 835.856 2129.55 850.74 2123.72Z",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M830.018 2070.81C815.679 2076.42 808.608 2092.6 814.223 2106.94C819.838 2121.28 836.013 2128.35 850.352 2122.73C864.69 2117.12 871.762 2100.94 866.147 2086.6C860.532 2072.27 844.356 2065.19 830.018 2070.81ZM812.246 2107.71C806.203 2092.28 813.813 2074.87 829.244 2068.83C844.674 2062.79 862.081 2070.4 868.124 2085.83C874.166 2101.26 866.556 2118.67 851.126 2124.71C835.696 2130.75 818.288 2123.14 812.246 2107.71Z",
    fill: "#9C9C9C"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M952.029 2084.06C966.913 2078.23 974.254 2061.44 968.426 2046.55C962.597 2031.67 945.805 2024.33 930.921 2030.16C916.037 2035.99 908.696 2052.78 914.525 2067.66C920.353 2082.55 937.145 2089.89 952.029 2084.06Z",
    fill: "white"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M931.307 2031.15C916.969 2036.76 909.897 2052.94 915.512 2067.27C921.127 2081.61 937.302 2088.68 951.641 2083.07C965.979 2077.45 973.051 2061.28 967.436 2046.94C961.821 2032.6 945.645 2025.53 931.307 2031.15ZM913.535 2068.05C907.492 2052.62 915.102 2035.21 930.533 2029.17C945.963 2023.13 963.37 2030.74 969.413 2046.17C975.455 2061.6 967.845 2079 952.415 2085.05C936.985 2091.09 919.577 2083.48 913.535 2068.05Z",
    fill: "#9C9C9C"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M914.923 98.2143L799.71 143.332L798.936 141.355L914.149 96.2373L914.923 98.2143Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M925.388 124.941L810.175 170.059L809.4 168.082L924.613 122.964L925.388 124.941Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M938.845 159.3L823.632 204.418L822.857 202.441L938.071 157.323L938.845 159.3Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M949.399 186.253L834.186 231.372L833.412 229.395L948.625 184.276L949.399 186.253Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M847.168 264.52L871.648 254.933L962.381 219.401",
    fill: "white"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M847.168 264.52L871.648 254.933L962.381 219.401",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M847.554 265.508L846.779 263.531L961.992 218.413L962.767 220.39L847.554 265.508Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M870.649 255.293L792.654 41.5729L794.648 40.845L872.644 254.565L870.649 255.293Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M895.13 245.707L817.134 31.987L819.129 31.2591L897.124 244.98L895.13 245.707Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7414 352.569L198.133 311.296L232.282 398.497L126.89 439.769L92.7414 352.569Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.113 304.716L268.6 380.967L267.12 381.617L233.633 305.366L235.113 304.716Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.477 291.263L302.739 367.602L301.257 368.247L267.995 291.908L269.477 291.263Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.961 277.364L338.223 353.703L336.741 354.349L303.479 278.01L304.961 277.364Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.097 263.993L372.584 340.244L371.105 340.894L337.618 264.643L339.097 263.993Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.725 540.692L121.939 519.883L123.07 517.665L163.857 538.474L162.725 540.692Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1014.57 2015.57L743.365 2120.74L742.465 2118.42L1013.67 2013.25L1014.57 2015.57Z",
    fill: "#9C9C9C"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M812.294 2114.95L799.805 2083.05L802.124 2082.15L814.612 2114.04L812.294 2114.95Z",
    fill: "#9C9C9C"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M787.813 2124.53L775.324 2092.64L777.643 2091.73L790.132 2123.62L787.813 2124.53Z",
    fill: "#9C9C9C"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M861.926 2095.51L849.438 2063.62L851.756 2062.71L864.245 2094.6L861.926 2095.51Z",
    fill: "#9C9C9C"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M837.446 2105.09L824.957 2073.2L827.276 2072.3L839.765 2104.19L837.446 2105.09Z",
    fill: "#9C9C9C"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M910.213 2076.6L897.725 2044.71L900.043 2043.8L912.532 2075.69L910.213 2076.6Z",
    fill: "#9C9C9C"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M885.733 2086.19L873.244 2054.3L875.563 2053.39L888.052 2085.28L885.733 2086.19Z",
    fill: "#9C9C9C"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M959.846 2057.16L947.357 2025.27L949.676 2024.37L962.165 2056.26L959.846 2057.16Z",
    fill: "#9C9C9C"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M935.366 2066.75L922.877 2034.86L925.196 2033.95L937.685 2065.84L935.366 2066.75Z",
    fill: "#9C9C9C"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1006.34 2038.96L993.848 2007.07L996.166 2006.16L1008.66 2038.05L1006.34 2038.96Z",
    fill: "#9C9C9C"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M981.856 2048.54L969.367 2016.65L971.686 2015.74L984.175 2047.64L981.856 2048.54Z",
    fill: "#9C9C9C"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.167 556.688L87.4685 597.291L86.5451 594.978L188.244 554.376L189.167 556.688Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.04 584.468L93.6626 622.324L92.7094 620.023L184.087 582.167L185.04 584.468Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.665 667.79L126.2 705.422L125.252 703.119L216.717 665.487L217.665 667.79Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.762 639.937L115.385 677.793L114.432 675.492L205.809 637.636L206.762 639.937Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.975 609.845L103.51 647.477L102.563 645.174L194.028 607.542L194.975 609.845Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.669 688.228L134.204 725.859L133.256 723.556L224.721 685.925L225.669 688.228Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.21 771.326L166.745 808.957L165.797 806.654L257.262 769.023L258.21 771.326Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.393 743.701L155.928 781.332L154.981 779.029L246.446 741.398L247.393 743.701Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.52 713.38L144.055 751.012L143.108 748.709L234.573 711.077L235.52 713.38Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.182 794.232L175.717 831.863L174.77 829.56L266.235 791.929L267.182 794.232Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.738 877.324L240.028 902.779L239.051 900.488L298.762 875.033L299.738 877.324Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.486 897.081L264.981 915.54L263.989 913.256L306.494 894.797L307.486 897.081Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M316.105 919.089L273.6 937.548L272.608 935.263L315.113 916.805L316.105 919.089Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.31 965.581L291.805 984.04L290.813 981.756L333.318 963.297L334.31 965.581Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.372 940.203L281.867 958.661L280.875 956.377L323.38 937.918L324.372 940.203Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.863 992.535L302.358 1010.99L301.366 1008.71L343.871 990.25L344.863 992.535Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M353.482 1014.54L310.977 1033L309.985 1030.72L352.49 1012.26L353.482 1014.54Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.687 1061.03L329.182 1079.49L328.19 1077.21L370.695 1058.75L371.687 1061.03Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M361.749 1035.66L319.244 1054.11L318.252 1051.83L360.757 1033.37L361.749 1035.66Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.544 1086.18L339.127 1104.86L338.124 1102.59L380.541 1083.9L381.544 1086.18Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.164 1108.19L347.746 1126.87L346.743 1124.59L389.16 1105.91L390.164 1108.19Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.369 1154.68L365.952 1173.36L364.948 1171.09L407.365 1152.4L408.369 1154.68Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M398.513 1129.53L356.008 1147.99L355.016 1145.7L397.521 1127.25L398.513 1129.53Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M418.923 1181.63L376.506 1200.31L375.502 1198.03L417.92 1179.35L418.923 1181.63Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M427.542 1203.64L385.125 1222.32L384.122 1220.04L426.539 1201.36L427.542 1203.64Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M445.748 1250.13L403.33 1268.81L402.327 1266.53L444.744 1247.85L445.748 1250.13Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435.892 1224.98L393.387 1243.44L392.395 1241.15L434.9 1222.7L435.892 1224.98Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M454.542 1272.59L412.125 1291.27L411.122 1288.99L453.539 1270.31L454.542 1272.59Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M463.162 1294.6L420.745 1313.28L419.741 1311L462.158 1292.32L463.162 1294.6Z",
    fill: "#9C9C9C"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M481.367 1341.09L438.95 1359.77L437.946 1357.49L480.363 1338.81L481.367 1341.09Z",
    fill: "#9C9C9C"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.511 1315.94L429.006 1334.4L428.014 1332.11L470.519 1313.65L471.511 1315.94Z",
    fill: "#9C9C9C"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M491.3 1366.47L448.795 1384.93L447.803 1382.65L490.308 1364.19L491.3 1366.47Z",
    fill: "#9C9C9C"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M499.919 1388.48L457.414 1406.94L456.422 1404.65L498.927 1386.2L499.919 1388.48Z",
    fill: "#9C9C9C"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M518.124 1434.97L475.619 1453.43L474.627 1451.15L517.132 1432.69L518.124 1434.97Z",
    fill: "#9C9C9C"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M508.275 1409.82L465.77 1428.27L464.778 1425.99L507.283 1407.53L508.275 1409.82Z",
    fill: "#9C9C9C"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M528.677 1461.92L486.172 1480.38L485.18 1478.09L527.685 1459.63L528.677 1461.92Z",
    fill: "#9C9C9C"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M537.296 1483.93L494.791 1502.38L493.799 1500.1L536.304 1481.64L537.296 1483.93Z",
    fill: "#9C9C9C"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M555.501 1530.42L512.996 1548.88L512.004 1546.59L554.509 1528.13L555.501 1530.42Z",
    fill: "#9C9C9C"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M545.652 1505.26L503.147 1523.72L502.155 1521.44L544.66 1502.98L545.652 1505.26Z",
    fill: "#9C9C9C"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M564.298 1552.88L521.793 1571.34L520.801 1569.05L563.306 1550.59L564.298 1552.88Z",
    fill: "#9C9C9C"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M572.917 1574.89L530.412 1593.34L529.42 1591.06L571.925 1572.6L572.917 1574.89Z",
    fill: "#9C9C9C"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M591.122 1621.38L548.617 1639.84L547.625 1637.55L590.13 1619.09L591.122 1621.38Z",
    fill: "#9C9C9C"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M581.273 1596.22L538.768 1614.68L537.776 1612.4L580.281 1593.94L581.273 1596.22Z",
    fill: "#9C9C9C"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M601.062 1646.75L558.557 1665.21L557.565 1662.93L600.07 1644.47L601.062 1646.75Z",
    fill: "#9C9C9C"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M609.681 1668.77L567.176 1687.22L566.184 1684.94L608.689 1666.48L609.681 1668.77Z",
    fill: "#9C9C9C"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M627.886 1715.25L585.381 1733.71L584.389 1731.43L626.894 1712.97L627.886 1715.25Z",
    fill: "#9C9C9C"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M617.955 1689.87L575.537 1708.56L574.534 1706.28L616.951 1687.59L617.955 1689.87Z",
    fill: "#9C9C9C"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M638.439 1742.2L595.934 1760.66L594.942 1758.38L637.447 1739.92L638.439 1742.2Z",
    fill: "#9C9C9C"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M647.058 1764.21L604.553 1782.67L603.561 1780.39L646.066 1761.93L647.058 1764.21Z",
    fill: "#9C9C9C"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M665.263 1810.7L622.758 1829.16L621.766 1826.88L664.271 1808.42L665.263 1810.7Z",
    fill: "#9C9C9C"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M655.332 1785.32L612.914 1804.01L611.911 1801.73L654.328 1783.04L655.332 1785.32Z",
    fill: "#9C9C9C"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M673.091 1830.69L630.586 1849.15L629.594 1846.87L672.099 1828.41L673.091 1830.69Z",
    fill: "#9C9C9C"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M681.71 1852.7L639.205 1871.16L638.213 1868.88L680.718 1850.42L681.71 1852.7Z",
    fill: "#9C9C9C"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M699.915 1899.19L657.41 1917.65L656.418 1915.37L698.923 1896.91L699.915 1899.19Z",
    fill: "#9C9C9C"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M689.984 1873.81L647.567 1892.49L646.563 1890.21L688.98 1871.53L689.984 1873.81Z",
    fill: "#9C9C9C"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M709.855 1924.57L667.35 1943.03L666.358 1940.74L708.863 1922.29L709.855 1924.57Z",
    fill: "#9C9C9C"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M718.474 1946.58L675.969 1965.04L674.977 1962.75L717.482 1944.29L718.474 1946.58Z",
    fill: "#9C9C9C"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M736.679 1993.07L694.174 2011.53L693.182 2009.24L735.687 1990.79L736.679 1993.07Z",
    fill: "#9C9C9C"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M726.742 1967.69L684.237 1986.15L683.245 1983.87L725.75 1965.41L726.742 1967.69Z",
    fill: "#9C9C9C"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M747.234 2020.02L704.729 2038.48L703.737 2036.19L746.242 2017.73L747.234 2020.02Z",
    fill: "#9C9C9C"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M755.853 2042.03L713.348 2060.49L712.356 2058.2L754.861 2039.74L755.853 2042.03Z",
    fill: "#9C9C9C"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M774.058 2088.52L731.553 2106.98L730.561 2104.69L773.066 2086.23L774.058 2088.52Z",
    fill: "#9C9C9C"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M764.12 2063.14L721.615 2081.6L720.623 2079.31L763.129 2060.86L764.12 2063.14Z",
    fill: "#9C9C9C"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.91 849.703L216.984 879.683L216.026 877.385L287.952 847.405L288.91 849.703Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.035 819.384L191.273 855.041L190.317 852.742L276.079 817.085L277.035 819.384Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M356.717 473.739L356.718 473.735C358.427 467.568 362.98 462.779 368.793 460.496L469.556 422.85L469.574 422.843L469.592 422.836C475.342 420.584 481.787 421.257 487.045 424.711L487.067 424.726L487.09 424.74L504.508 435.653L350.522 495.955L356.717 473.739Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M609.153 374.883L609.154 374.879C610.862 368.712 615.416 363.923 621.229 361.641L721.991 323.994L722.009 323.987L722.028 323.98C727.778 321.728 734.222 322.401 739.48 325.856L739.503 325.871L739.526 325.885L756.943 336.798L602.957 397.1L609.153 374.883Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M728.079 704.971L881.308 644.966L889.511 665.913L736.282 725.918L728.079 704.971Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M763.259 794.807L916.488 734.801L924.691 755.749L771.462 815.754L763.259 794.807Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M798.527 884.865L951.755 824.86L959.959 845.807L806.73 905.813L798.527 884.865Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M830.804 967.287L984.033 907.282L992.236 928.229L839.007 988.235L830.804 967.287Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M866.072 1057.35L1019.3 997.344L1027.5 1018.29L874.275 1078.3L866.072 1057.35Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M901.253 1147.19L1054.48 1087.18L1062.69 1108.13L909.456 1168.13L901.253 1147.19Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M937.927 1240.84L1091.16 1180.83L1099.36 1201.78L946.13 1261.79L937.927 1240.84Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M1127.84 1267.65L969.957 1329.48L979.983 1355.08L1137.87 1293.25L1127.84 1267.65Z",
    fill: "#9C9C9C"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.02 1357.48L1005.13 1419.31L1015.16 1444.92L1173.05 1383.09L1163.02 1357.48Z",
    fill: "#9C9C9C"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.09 1441.93L1038.21 1503.76L1048.23 1529.36L1206.12 1467.53L1196.09 1441.93Z",
    fill: "#9C9C9C"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M1231.36 1531.99L1073.47 1593.82L1083.5 1619.42L1241.38 1557.59L1231.36 1531.99Z",
    fill: "#9C9C9C"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M1266.54 1621.82L1108.65 1683.65L1118.68 1709.26L1276.56 1647.43L1266.54 1621.82Z",
    fill: "#9C9C9C"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M859.831 306.537L935.128 277.05L943.507 298.447L868.21 327.934L859.831 306.537Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M938.286 329.58L932.178 313.322L934.249 312.544L940.357 328.802L938.286 329.58Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M921.482 321.008L926.669 334.536L908.187 341.622L903 328.094L921.482 321.008ZM920.223 323.833L905.825 329.353L909.446 338.797L923.844 333.277L920.223 323.833Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M924.918 326.145L937.27 321.307L938.068 323.344L925.715 328.181L924.918 326.145Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M951.127 362.368L944.932 345.885L947.003 345.106L953.199 361.589L951.127 362.368Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M934.104 353.699L939.29 367.227L920.808 374.313L915.621 360.786L934.104 353.699ZM932.844 356.524L918.446 362.045L922.067 371.489L936.465 365.968L932.844 356.524Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M937.689 358.7L950.13 354.088L950.89 356.138L938.45 360.751L937.689 358.7Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M895.626 397.944L970.923 368.457L979.302 389.853L904.005 419.34L895.626 397.944Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M957.698 332.459L880.216 362.801L879.441 360.824L956.924 330.482L957.698 332.459Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M972.85 417.844L966.654 401.361L968.725 400.583L974.921 417.065L972.85 417.844Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M955.854 409.188L961.04 422.715L942.558 429.802L937.371 416.274L955.854 409.188ZM954.594 412.012L940.196 417.533L943.817 426.977L958.215 421.456L954.594 412.012Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M959.414 414.177L971.854 409.564L972.614 411.615L960.174 416.227L959.414 414.177Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M985.602 450.41L979.406 433.928L981.477 433.149L987.673 449.632L985.602 450.41Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M968.699 441.797L973.886 455.325L955.403 462.411L950.217 448.883L968.699 441.797ZM967.44 444.622L953.042 450.142L956.662 459.586L971.061 454.066L967.44 444.622Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M972.234 446.973L984.587 442.135L985.384 444.172L973.032 449.009L972.234 446.973Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M930.103 485.983L1005.4 456.496L1013.78 477.892L938.482 507.379L930.103 485.983Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M992.175 420.498L914.692 450.84L913.918 448.863L991.4 418.521L992.175 420.498Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1121.48 831.727L1126.66 845.254L1108.18 852.341L1102.99 838.813L1121.48 831.727ZM1120.22 834.551L1105.82 840.072L1109.44 849.516L1123.84 843.995L1120.22 834.551Z",
    fill: "#9C9C9C"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1207.85 1017.94L1201.66 1001.46L1203.73 1000.68L1209.92 1017.16L1207.85 1017.94Z",
    fill: "#9C9C9C"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1190.98 1009.16L1196.16 1022.69L1177.68 1029.78L1172.49 1016.25L1190.98 1009.16ZM1189.72 1011.99L1175.32 1017.51L1178.94 1026.95L1193.34 1021.43L1189.72 1011.99Z",
    fill: "#9C9C9C"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1194.42 1014.27L1206.86 1009.66L1207.62 1011.71L1195.18 1016.32L1194.42 1014.27Z",
    fill: "#9C9C9C"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1220.6 1050.51L1214.41 1034.03L1216.48 1033.25L1222.68 1049.73L1220.6 1050.51Z",
    fill: "#9C9C9C"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1203.6 1041.86L1208.78 1055.39L1190.3 1062.47L1185.11 1048.95L1203.6 1041.86ZM1202.34 1044.68L1187.94 1050.2L1191.56 1059.65L1205.96 1054.13L1202.34 1044.68Z",
    fill: "#9C9C9C"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1207.17 1046.84L1219.61 1042.23L1220.37 1044.28L1207.93 1048.89L1207.17 1046.84Z",
    fill: "#9C9C9C"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M1241.82 1053.35L1161.87 1084.66L1172.07 1110.72L1252.02 1079.41L1241.82 1053.35Z",
    fill: "#9C9C9C"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1227.18 1020.6L1149.69 1050.94L1148.92 1048.96L1226.4 1018.62L1227.18 1020.6Z",
    fill: "#9C9C9C"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1241.36 1103.51L1235.17 1087.03L1237.24 1086.25L1243.43 1102.73L1241.36 1103.51Z",
    fill: "#9C9C9C"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1224.36 1094.87L1229.55 1108.39L1211.07 1115.48L1205.88 1101.95L1224.36 1094.87ZM1223.1 1097.69L1208.7 1103.21L1212.32 1112.66L1226.72 1107.14L1223.1 1097.69Z",
    fill: "#9C9C9C"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1227.93 1099.84L1240.37 1095.23L1241.13 1097.28L1228.69 1101.89L1227.93 1099.84Z",
    fill: "#9C9C9C"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1254.12 1136.08L1248.01 1119.82L1250.08 1119.04L1256.19 1135.3L1254.12 1136.08Z",
    fill: "#9C9C9C"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1237.21 1127.48L1242.4 1141L1223.91 1148.09L1218.73 1134.56L1237.21 1127.48ZM1235.95 1130.3L1221.55 1135.82L1225.17 1145.27L1239.57 1139.75L1235.95 1130.3Z",
    fill: "#9C9C9C"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1240.75 1132.64L1253.1 1127.8L1253.9 1129.84L1241.55 1134.68L1240.75 1132.64Z",
    fill: "#9C9C9C"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M1275.33 1138.92L1195.38 1170.23L1205.58 1196.29L1285.53 1164.98L1275.33 1138.92Z",
    fill: "#9C9C9C"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1260.69 1106.17L1183.2 1136.51L1182.43 1134.53L1259.91 1104.19L1260.69 1106.17Z",
    fill: "#9C9C9C"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1276.44 1193.12L1270.16 1176.42L1272.26 1175.63L1278.54 1192.33L1276.44 1193.12Z",
    fill: "#9C9C9C"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1259.28 1184.19L1264.57 1197.97L1246.06 1205.07L1240.77 1191.29L1259.28 1184.19ZM1258.01 1187.05L1243.64 1192.57L1247.34 1202.2L1261.7 1196.69L1258.01 1187.05Z",
    fill: "#9C9C9C"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1263.01 1189.43L1275.45 1184.82L1276.22 1186.9L1263.78 1191.51L1263.01 1189.43Z",
    fill: "#9C9C9C"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1289.63 1226.81L1283.26 1209.88L1285.36 1209.09L1291.73 1226.02L1289.63 1226.81Z",
    fill: "#9C9C9C"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1272.56 1217.73L1277.85 1231.51L1259.34 1238.61L1254.05 1224.83L1272.56 1217.73ZM1271.28 1220.59L1256.91 1226.1L1260.61 1235.74L1274.98 1230.23L1271.28 1220.59Z",
    fill: "#9C9C9C"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1276.19 1223.13L1288.54 1218.3L1289.35 1220.36L1276.99 1225.2L1276.19 1223.13Z",
    fill: "#9C9C9C"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M1311.03 1230.1L1231.08 1261.41L1241.64 1288.36L1321.59 1257.05L1311.03 1230.1Z",
    fill: "#9C9C9C"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1295.96 1196.24L1218.48 1226.58L1217.69 1224.57L1295.17 1194.23L1295.96 1196.24Z",
    fill: "#9C9C9C"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1370.37 1432.98L1364 1416.05L1366.1 1415.26L1372.47 1432.19L1370.37 1432.98Z",
    fill: "#9C9C9C"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1353.18 1423.85L1358.47 1437.63L1339.96 1444.73L1334.67 1430.95L1353.18 1423.85ZM1351.91 1426.71L1337.54 1432.23L1341.24 1441.86L1355.6 1436.35L1351.91 1426.71Z",
    fill: "#9C9C9C"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1356.85 1429.07L1369.29 1424.45L1370.06 1426.53L1357.62 1431.15L1356.85 1429.07Z",
    fill: "#9C9C9C"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1383.47 1466.45L1377.1 1449.51L1379.2 1448.72L1385.57 1465.65L1383.47 1466.45Z",
    fill: "#9C9C9C"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1366.46 1457.39L1371.74 1471.17L1353.23 1478.27L1347.95 1464.49L1366.46 1457.39ZM1365.18 1460.26L1350.81 1465.77L1354.51 1475.41L1368.88 1469.9L1365.18 1460.26Z",
    fill: "#9C9C9C"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1370.03 1462.77L1382.38 1457.93L1383.19 1459.99L1370.83 1464.83L1370.03 1462.77Z",
    fill: "#9C9C9C"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M1404.88 1469.74L1324.92 1501.05L1335.48 1528L1415.43 1496.69L1404.88 1469.74Z",
    fill: "#9C9C9C"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1389.8 1435.87L1312.32 1466.21L1311.53 1464.21L1389.02 1433.86L1389.8 1435.87Z",
    fill: "#9C9C9C"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1404.85 1521.02L1398.47 1504.09L1400.58 1503.3L1406.95 1520.23L1404.85 1521.02Z",
    fill: "#9C9C9C"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1387.76 1511.93L1393.04 1525.71L1374.53 1532.81L1369.25 1519.03L1387.76 1511.93ZM1386.48 1514.8L1372.11 1520.31L1375.81 1529.95L1390.18 1524.43L1386.48 1514.8Z",
    fill: "#9C9C9C"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1391.4 1517.34L1403.75 1512.5L1404.56 1514.56L1392.21 1519.4L1391.4 1517.34Z",
    fill: "#9C9C9C"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1418.04 1554.71L1411.67 1537.78L1413.77 1536.98L1420.14 1553.92L1418.04 1554.71Z",
    fill: "#9C9C9C"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1400.8 1545.56L1406.09 1559.34L1387.58 1566.44L1382.29 1552.66L1400.8 1545.56ZM1399.53 1548.42L1385.16 1553.94L1388.86 1563.58L1403.23 1558.06L1399.53 1548.42Z",
    fill: "#9C9C9C"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1404.52 1550.8L1416.96 1546.19L1417.73 1548.27L1405.29 1552.88L1404.52 1550.8Z",
    fill: "#9C9C9C"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M1439.35 1557.78L1359.4 1589.09L1369.95 1616.04L1449.91 1584.73L1439.35 1557.78Z",
    fill: "#9C9C9C"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1424.28 1523.91L1346.8 1554.25L1346.01 1552.25L1423.49 1521.9L1424.28 1523.91Z",
    fill: "#9C9C9C"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1439.32 1609.06L1433.04 1592.35L1435.14 1591.56L1441.42 1608.27L1439.32 1609.06Z",
    fill: "#9C9C9C"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1422.33 1600.02L1427.62 1613.8L1409.1 1620.9L1403.82 1607.12L1422.33 1600.02ZM1421.05 1602.88L1406.68 1608.39L1410.38 1618.03L1424.75 1612.52L1421.05 1602.88Z",
    fill: "#9C9C9C"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1425.88 1605.38L1438.23 1600.54L1439.04 1602.61L1426.69 1607.44L1425.88 1605.38Z",
    fill: "#9C9C9C"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1452.52 1642.75L1446.14 1625.81L1448.25 1625.02L1454.62 1641.96L1452.52 1642.75Z",
    fill: "#9C9C9C"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1435.38 1633.64L1440.66 1647.42L1422.15 1654.52L1416.87 1640.74L1435.38 1633.64ZM1434.1 1636.51L1419.73 1642.02L1423.43 1651.66L1437.8 1646.15L1434.1 1636.51Z",
    fill: "#9C9C9C"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1439.07 1639.07L1451.42 1634.23L1452.23 1636.29L1439.88 1641.13L1439.07 1639.07Z",
    fill: "#9C9C9C"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M1473.83 1645.81L1393.88 1677.12L1404.43 1704.07L1484.38 1672.76L1473.83 1645.81Z",
    fill: "#9C9C9C"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1458.75 1611.94L1381.27 1642.29L1380.49 1640.28L1457.97 1609.94L1458.75 1611.94Z",
    fill: "#9C9C9C"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1535.27 1854.08L1528.99 1837.38L1531.09 1836.59L1537.38 1853.29L1535.27 1854.08Z",
    fill: "#9C9C9C"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1518.3 1845.05L1523.59 1858.84L1505.08 1865.94L1499.79 1852.16L1518.3 1845.05ZM1517.03 1847.92L1502.66 1853.43L1506.36 1863.07L1520.72 1857.56L1517.03 1847.92Z",
    fill: "#9C9C9C"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1521.83 1850.4L1534.18 1845.57L1534.99 1847.63L1522.64 1852.47L1521.83 1850.4Z",
    fill: "#9C9C9C"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1548.47 1887.77L1542.1 1870.84L1544.2 1870.05L1550.57 1886.98L1548.47 1887.77Z",
    fill: "#9C9C9C"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1531.35 1878.68L1536.64 1892.46L1518.13 1899.56L1512.84 1885.78L1531.35 1878.68ZM1530.07 1881.55L1515.71 1887.06L1519.4 1896.7L1533.77 1891.18L1530.07 1881.55Z",
    fill: "#9C9C9C"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1535.02 1884.09L1547.37 1879.25L1548.18 1881.32L1535.83 1886.16L1535.02 1884.09Z",
    fill: "#9C9C9C"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M1569.78 1890.84L1489.83 1922.15L1500.38 1949.1L1580.34 1917.79L1569.78 1890.84Z",
    fill: "#9C9C9C"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1554.71 1856.97L1477.22 1887.31L1476.44 1885.31L1553.92 1854.97L1554.71 1856.97Z",
    fill: "#9C9C9C"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1476.08 1702.94L1469.71 1686.01L1471.81 1685.22L1478.18 1702.15L1476.08 1702.94Z",
    fill: "#9C9C9C"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1459 1693.86L1464.29 1707.64L1445.78 1714.74L1440.49 1700.96L1459 1693.86ZM1457.73 1696.73L1443.36 1702.24L1447.06 1711.88L1461.43 1706.36L1457.73 1696.73Z",
    fill: "#9C9C9C"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1462.64 1699.26L1474.99 1694.42L1475.8 1696.49L1463.45 1701.32L1462.64 1699.26Z",
    fill: "#9C9C9C"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1489.28 1736.63L1482.91 1719.69L1485.01 1718.9L1491.38 1735.83L1489.28 1736.63Z",
    fill: "#9C9C9C"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1472.05 1727.48L1477.34 1741.27L1458.83 1748.37L1453.54 1734.59L1472.05 1727.48ZM1470.78 1730.35L1456.41 1735.86L1460.11 1745.5L1474.48 1739.99L1470.78 1730.35Z",
    fill: "#9C9C9C"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1475.76 1732.71L1488.2 1728.1L1488.97 1730.18L1476.53 1734.79L1475.76 1732.71Z",
    fill: "#9C9C9C"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M1510.59 1739.69L1430.64 1771L1441.19 1797.95L1521.15 1766.64L1510.59 1739.69Z",
    fill: "#9C9C9C"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1495.52 1705.83L1418.03 1736.17L1417.25 1734.16L1494.73 1703.82L1495.52 1705.83Z",
    fill: "#9C9C9C"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1311 1281.39L1304.63 1264.46L1306.73 1263.66L1313.11 1280.6L1311 1281.39Z",
    fill: "#9C9C9C"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1293.91 1272.29L1299.2 1286.07L1280.68 1293.18L1275.4 1279.39L1293.91 1272.29ZM1292.63 1275.16L1278.26 1280.67L1281.96 1290.31L1296.33 1284.8L1292.63 1275.16Z",
    fill: "#9C9C9C"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1297.56 1277.71L1309.91 1272.87L1310.72 1274.94L1298.37 1279.77L1297.56 1277.71Z",
    fill: "#9C9C9C"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1324.11 1314.85L1317.82 1298.14L1319.93 1297.35L1326.21 1314.06L1324.11 1314.85Z",
    fill: "#9C9C9C"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1306.96 1305.92L1312.25 1319.7L1293.74 1326.8L1288.45 1313.02L1306.96 1305.92ZM1305.68 1308.78L1291.31 1314.3L1295.01 1323.93L1309.38 1318.42L1305.68 1308.78Z",
    fill: "#9C9C9C"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1310.68 1311.16L1323.12 1306.55L1323.89 1308.63L1311.45 1313.24L1310.68 1311.16Z",
    fill: "#9C9C9C"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1349.26 1379.08L1342.89 1362.15L1344.99 1361.36L1351.36 1378.29L1349.26 1379.08Z",
    fill: "#9C9C9C"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1332.09 1369.96L1337.38 1383.74L1318.87 1390.84L1313.58 1377.06L1332.09 1369.96ZM1330.82 1372.82L1316.45 1378.34L1320.15 1387.97L1334.51 1382.46L1330.82 1372.82Z",
    fill: "#9C9C9C"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1335.74 1375.17L1348.18 1370.56L1348.96 1372.64L1336.52 1377.25L1335.74 1375.17Z",
    fill: "#9C9C9C"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1573.71 1952.23L1567.43 1935.52L1569.53 1934.73L1575.81 1951.44L1573.71 1952.23Z",
    fill: "#9C9C9C"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1556.73 1943.2L1562.02 1956.98L1543.51 1964.09L1538.22 1950.3L1556.73 1943.2ZM1555.46 1946.07L1541.09 1951.58L1544.79 1961.22L1559.15 1955.71L1555.46 1946.07Z",
    fill: "#9C9C9C"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1560.26 1948.55L1572.61 1943.71L1573.42 1945.78L1561.07 1950.62L1560.26 1948.55Z",
    fill: "#9C9C9C"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1198.65 1758.48L1192.05 1741.64L1194.14 1740.82L1200.74 1757.67L1198.65 1758.48Z",
    fill: "#9C9C9C"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1181.4 1749.43L1186.69 1763.21L1168.18 1770.31L1162.89 1756.53L1181.4 1749.43ZM1180.12 1752.3L1165.76 1757.81L1169.45 1767.45L1183.82 1761.93L1180.12 1752.3Z",
    fill: "#9C9C9C"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1185.13 1754.56L1197.57 1749.94L1198.34 1752.02L1185.9 1756.64L1185.13 1754.56Z",
    fill: "#9C9C9C"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1239.53 1742.49L1232.71 1725.73L1234.79 1724.89L1241.61 1741.64L1239.53 1742.49Z",
    fill: "#9C9C9C"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1266.01 1716L1271.49 1729.71L1253.07 1737.06L1247.6 1723.36L1266.01 1716ZM1264.77 1718.88L1250.48 1724.59L1254.31 1734.18L1268.6 1728.47L1264.77 1718.88Z",
    fill: "#9C9C9C"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1249.49 1731.73L1237.45 1736.71L1236.61 1734.66L1248.65 1729.68L1249.49 1731.73Z",
    fill: "#9C9C9C"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1228.65 1830.48L1222.05 1813.64L1224.14 1812.82L1230.74 1829.67L1228.65 1830.48Z",
    fill: "#9C9C9C"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1258.65 1902.48L1252.05 1885.64L1254.14 1884.82L1260.74 1901.67L1258.65 1902.48Z",
    fill: "#9C9C9C"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1288.65 1974.48L1282.05 1957.64L1284.14 1956.82L1290.74 1973.67L1288.65 1974.48Z",
    fill: "#9C9C9C"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1318.65 2046.48L1312.05 2029.64L1314.14 2028.82L1320.74 2045.67L1318.65 2046.48Z",
    fill: "#9C9C9C"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1211.4 1821.43L1216.69 1835.21L1198.18 1842.31L1192.89 1828.53L1211.4 1821.43ZM1210.12 1824.3L1195.76 1829.81L1199.45 1839.45L1213.82 1833.93L1210.12 1824.3Z",
    fill: "#9C9C9C"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1241.4 1893.43L1246.69 1907.21L1228.18 1914.31L1222.89 1900.53L1241.4 1893.43ZM1240.12 1896.3L1225.76 1901.81L1229.45 1911.45L1243.82 1905.93L1240.12 1896.3Z",
    fill: "#9C9C9C"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1271.4 1965.43L1276.69 1979.21L1258.18 1986.31L1252.89 1972.53L1271.4 1965.43ZM1270.12 1968.3L1255.76 1973.81L1259.45 1983.45L1273.82 1977.93L1270.12 1968.3Z",
    fill: "#9C9C9C"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1301.4 2037.43L1306.69 2051.21L1288.18 2058.31L1282.89 2044.53L1301.4 2037.43ZM1300.12 2040.3L1285.76 2045.81L1289.45 2055.45L1303.82 2049.93L1300.12 2040.3Z",
    fill: "#9C9C9C"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1215.13 1826.56L1227.57 1821.94L1228.34 1824.02L1215.9 1828.64L1215.13 1826.56Z",
    fill: "#9C9C9C"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1245.13 1898.56L1257.57 1893.94L1258.34 1896.02L1245.9 1900.64L1245.13 1898.56Z",
    fill: "#9C9C9C"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1275.13 1970.56L1287.57 1965.94L1288.34 1968.02L1275.9 1972.64L1275.13 1970.56Z",
    fill: "#9C9C9C"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1305.13 2042.56L1317.57 2037.94L1318.34 2040.02L1305.9 2044.64L1305.13 2042.56Z",
    fill: "#9C9C9C"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1269.53 1814.49L1262.71 1797.73L1264.79 1796.89L1271.61 1813.64L1269.53 1814.49Z",
    fill: "#9C9C9C"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1299.53 1886.49L1292.71 1869.73L1294.79 1868.89L1301.61 1885.64L1299.53 1886.49Z",
    fill: "#9C9C9C"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1329.53 1958.49L1322.71 1941.73L1324.79 1940.89L1331.61 1957.64L1329.53 1958.49Z",
    fill: "#9C9C9C"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1359.53 2030.49L1352.71 2013.73L1354.79 2012.89L1361.61 2029.64L1359.53 2030.49Z",
    fill: "#9C9C9C"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1296.01 1788L1301.49 1801.71L1283.07 1809.06L1277.6 1795.36L1296.01 1788ZM1294.77 1790.88L1280.48 1796.59L1284.31 1806.18L1298.6 1800.47L1294.77 1790.88Z",
    fill: "#9C9C9C"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1326.01 1860L1331.49 1873.71L1313.07 1881.06L1307.6 1867.36L1326.01 1860ZM1324.77 1862.88L1310.48 1868.59L1314.31 1878.18L1328.6 1872.47L1324.77 1862.88Z",
    fill: "#9C9C9C"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1356.01 1932L1361.49 1945.71L1343.07 1953.06L1337.6 1939.36L1356.01 1932ZM1354.77 1934.88L1340.48 1940.59L1344.31 1950.18L1358.6 1944.47L1354.77 1934.88Z",
    fill: "#9C9C9C"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1386.01 2004L1391.49 2017.71L1373.07 2025.06L1367.6 2011.36L1386.01 2004ZM1384.77 2006.88L1370.48 2012.59L1374.31 2022.18L1388.6 2016.47L1384.77 2006.88Z",
    fill: "#9C9C9C"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1279.49 1803.73L1267.45 1808.71L1266.61 1806.66L1278.65 1801.68L1279.49 1803.73Z",
    fill: "#9C9C9C"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1309.49 1875.73L1297.45 1880.71L1296.61 1878.66L1308.65 1873.68L1309.49 1875.73Z",
    fill: "#9C9C9C"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1339.49 1947.73L1327.45 1952.71L1326.61 1950.66L1338.65 1945.68L1339.49 1947.73Z",
    fill: "#9C9C9C"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1369.49 2019.73L1357.45 2024.71L1356.61 2022.66L1368.65 2017.68L1369.49 2019.73Z",
    fill: "#9C9C9C"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M1370.14 1381.03L1290.18 1412.34L1300.74 1439.29L1380.69 1407.98L1370.14 1381.03Z",
    fill: "#9C9C9C"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1512.67 1796.36L1506.3 1779.43L1508.4 1778.64L1514.77 1795.57L1512.67 1796.36Z",
    fill: "#9C9C9C"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1495.46 1787.23L1500.75 1801.01L1482.24 1808.11L1476.95 1794.33L1495.46 1787.23ZM1494.19 1790.1L1479.82 1795.61L1483.52 1805.25L1497.89 1799.74L1494.19 1790.1Z",
    fill: "#9C9C9C"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1499.16 1792.45L1511.6 1787.84L1512.37 1789.92L1499.93 1794.53L1499.16 1792.45Z",
    fill: "#9C9C9C"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M1533.55 1798.31L1453.59 1829.62L1464.15 1856.57L1544.1 1825.26L1533.55 1798.31Z",
    fill: "#9C9C9C"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M1344.54 1315.67L1264.59 1346.98L1275.14 1373.93L1355.1 1342.62L1344.54 1315.67Z",
    fill: "#9C9C9C"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1330.44 1284.27L1252.95 1314.62L1252.17 1312.61L1329.65 1282.27L1330.44 1284.27Z",
    fill: "#9C9C9C"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1006.97 504.983L1000.87 488.725L1002.94 487.946L1009.05 504.205L1006.97 504.983Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M990.166 496.414L995.353 509.942L976.87 517.028L971.684 503.5L990.166 496.414ZM988.907 499.239L974.508 504.759L978.129 514.203L992.528 508.683L988.907 499.239Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M993.607 501.547L1005.96 496.71L1006.76 498.746L994.405 503.583L993.607 501.547Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1019.81 537.77L1013.62 521.287L1015.69 520.508L1021.89 536.991L1019.81 537.77Z",
    fill: "#9C9C9C"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1002.79 529.102L1007.97 542.629L989.489 549.716L984.303 536.188L1002.79 529.102ZM1001.53 531.926L987.127 537.447L990.748 546.891L1005.15 541.37L1001.53 531.926Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1006.38 534.103L1018.82 529.49L1019.58 531.54L1007.14 536.153L1006.38 534.103Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M964.316 573.346L1039.61 543.859L1047.99 565.255L972.695 594.742L964.316 573.346Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M1135.93 782.948L1055.97 814.258L1066.17 840.31L1146.13 809L1135.93 782.948Z",
    fill: "#9C9C9C"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1026.39 507.865L948.905 538.207L948.131 536.23L1025.61 505.888L1026.39 507.865Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1041.54 593.246L1035.34 576.764L1037.41 575.985L1043.61 592.468L1041.54 593.246Z",
    fill: "#9C9C9C"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1024.54 584.59L1029.72 598.118L1011.24 605.204L1006.05 591.676L1024.54 584.59ZM1023.28 587.415L1008.88 592.935L1012.5 602.379L1026.9 596.859L1023.28 587.415Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1028.1 589.579L1040.54 584.967L1041.3 587.017L1028.86 591.63L1028.1 589.579Z",
    fill: "#9C9C9C"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1054.29 625.813L1048.1 609.33L1050.17 608.551L1056.36 625.034L1054.29 625.813Z",
    fill: "#9C9C9C"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1037.38 617.199L1042.57 630.727L1024.08 637.813L1018.9 624.286L1037.38 617.199ZM1036.12 620.024L1021.72 625.545L1025.34 634.989L1039.74 629.468L1036.12 620.024Z",
    fill: "#9C9C9C"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1040.93 622.379L1053.28 617.542L1054.08 619.578L1041.72 624.415L1040.93 622.379Z",
    fill: "#9C9C9C"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M998.792 661.389L1074.09 631.902L1082.47 653.298L1007.17 682.785L998.792 661.389Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1060.86 595.904L983.382 626.247L982.607 624.27L1060.09 593.927L1060.86 595.904Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1077.42 684.875L1071.23 668.393L1073.3 667.614L1079.5 684.097L1077.42 684.875Z",
    fill: "#9C9C9C"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1060.54 676.094L1065.73 689.622L1047.25 696.708L1042.06 683.18L1060.54 676.094ZM1059.28 678.919L1044.89 684.439L1048.51 693.883L1062.9 688.362L1059.28 678.919Z",
    fill: "#9C9C9C"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1063.97 681.219L1076.32 676.382L1077.12 678.418L1064.77 683.255L1063.97 681.219Z",
    fill: "#9C9C9C"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1090.18 717.442L1083.98 700.959L1086.05 700.18L1092.25 716.663L1090.18 717.442Z",
    fill: "#9C9C9C"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1073.16 708.789L1078.35 722.317L1059.87 729.403L1054.68 715.875L1073.16 708.789ZM1071.9 711.614L1057.5 717.134L1061.13 726.578L1075.52 721.058L1071.9 711.614Z",
    fill: "#9C9C9C"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M1308.16 1722.85L1150.73 1784.5L1160.31 1808.98L1317.75 1747.33L1308.16 1722.85Z",
    fill: "#9C9C9C"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1150.08 1784.22L1308.44 1722.2L1318.4 1747.61L1160.03 1809.63L1150.08 1784.22ZM1151.37 1784.79L1160.6 1808.33L1317.1 1747.05L1307.88 1723.5L1151.37 1784.79Z",
    fill: "#9C9C9C"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1215.97 1759.99L1204.8 1731.46L1205.73 1731.1L1216.9 1759.62L1215.97 1759.99Z",
    fill: "#9C9C9C"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1227.42 1755.5L1216.25 1726.98L1217.18 1726.62L1228.35 1755.14L1227.42 1755.5Z",
    fill: "#9C9C9C"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1076.74 713.778L1089.18 709.166L1089.94 711.216L1077.5 715.829L1076.74 713.778Z",
    fill: "#9C9C9C"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M1111.39 720.291L1031.44 751.602L1041.64 777.654L1121.59 746.344L1111.39 720.291Z",
    fill: "#9C9C9C"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1096.75 687.533L1019.26 717.875L1018.49 715.898L1095.97 685.556L1096.75 687.533Z",
    fill: "#9C9C9C"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1114.54 779.653L1108.34 763.17L1110.41 762.391L1116.61 778.874L1114.54 779.653Z",
    fill: "#9C9C9C"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1097.55 771.012L1102.74 784.539L1084.25 791.626L1079.07 778.098L1097.55 771.012ZM1096.29 773.837L1081.89 779.357L1085.51 788.801L1099.91 783.28L1096.29 773.837Z",
    fill: "#9C9C9C"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1101.1 775.986L1113.54 771.373L1114.3 773.423L1101.86 778.036L1101.1 775.986Z",
    fill: "#9C9C9C"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M1338.16 1794.85L1180.73 1856.5L1190.31 1880.98L1347.75 1819.33L1338.16 1794.85Z",
    fill: "#9C9C9C"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M1368.16 1866.85L1210.73 1928.5L1220.31 1952.98L1377.75 1891.33L1368.16 1866.85Z",
    fill: "#9C9C9C"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M1398.16 1938.85L1240.73 2000.5L1250.31 2024.98L1407.75 1963.33L1398.16 1938.85Z",
    fill: "#9C9C9C"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M1428.16 2010.85L1270.73 2072.5L1280.31 2096.98L1437.75 2035.33L1428.16 2010.85Z",
    fill: "#9C9C9C"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1180.08 1856.22L1338.44 1794.2L1348.4 1819.61L1190.03 1881.63L1180.08 1856.22ZM1181.37 1856.79L1190.6 1880.33L1347.1 1819.05L1337.88 1795.5L1181.37 1856.79Z",
    fill: "#9C9C9C"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1210.08 1928.22L1368.44 1866.2L1378.4 1891.61L1220.03 1953.63L1210.08 1928.22ZM1211.37 1928.79L1220.6 1952.33L1377.1 1891.05L1367.88 1867.5L1211.37 1928.79Z",
    fill: "#9C9C9C"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1240.08 2000.22L1398.44 1938.2L1408.4 1963.61L1250.03 2025.63L1240.08 2000.22ZM1241.37 2000.79L1250.6 2024.33L1407.1 1963.05L1397.88 1939.5L1241.37 2000.79Z",
    fill: "#9C9C9C"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1270.08 2072.22L1428.44 2010.2L1438.4 2035.61L1280.03 2097.63L1270.08 2072.22ZM1271.37 2072.79L1280.6 2096.33L1437.1 2035.05L1427.88 2011.5L1271.37 2072.79Z",
    fill: "#9C9C9C"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1245.97 1831.99L1234.8 1803.46L1235.73 1803.1L1246.9 1831.62L1245.97 1831.99Z",
    fill: "#9C9C9C"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1275.97 1903.99L1264.8 1875.46L1265.73 1875.1L1276.9 1903.62L1275.97 1903.99Z",
    fill: "#9C9C9C"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1305.97 1975.99L1294.8 1947.46L1295.73 1947.1L1306.9 1975.62L1305.97 1975.99Z",
    fill: "#9C9C9C"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1335.97 2047.99L1324.8 2019.46L1325.73 2019.1L1336.9 2047.62L1335.97 2047.99Z",
    fill: "#9C9C9C"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1257.42 1827.5L1246.25 1798.98L1247.18 1798.62L1258.35 1827.14L1257.42 1827.5Z",
    fill: "#9C9C9C"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1287.42 1899.5L1276.25 1870.98L1277.18 1870.62L1288.35 1899.14L1287.42 1899.5Z",
    fill: "#9C9C9C"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1317.42 1971.5L1306.25 1942.98L1307.18 1942.62L1318.35 1971.14L1317.42 1971.5Z",
    fill: "#9C9C9C"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1347.42 2043.5L1336.25 2014.98L1337.18 2014.62L1348.35 2043.14L1347.42 2043.5Z",
    fill: "#9C9C9C"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M837.969 1505.3L826.971 1477.3L894.971 1451.3L905.971 1479.8L837.969 1505.3Z",
    fill: "#FF1717"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M405.469 327.297L368.971 245.797L402.971 232.797L438.471 313.797L405.469 327.297Z",
    fill: "#FE763B",
    stroke: "#9C9C9C",
    strokeWidth: 5
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M474.973 299.797L438.973 219.297L670.973 130.297L704.973 210.297L474.973 299.797Z",
    fill: "#6CDD59",
    stroke: "#9C9C9C",
    strokeWidth: 5
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.338 250.981L405.6 327.321L404.118 327.966L370.856 251.627L372.338 250.981Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.477 237.61L439.739 313.949L438.257 314.595L404.995 238.256L406.477 237.61Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M441.961 223.712L475.448 299.963L473.968 300.613L440.481 224.362L441.961 223.712Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M476.322 210.259L509.585 286.598L508.103 287.243L474.841 210.904L476.322 210.259Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M507.988 197.856L541.475 274.108L539.995 274.758L506.508 198.506L507.988 197.856Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M542.352 184.403L575.614 260.742L574.132 261.388L540.87 185.049L542.352 184.403Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M577.836 170.505L611.098 246.844L609.616 247.49L576.354 171.15L577.836 170.505Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M612.197 157.052L645.46 233.391L643.978 234.036L610.716 157.697L612.197 157.052Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M708.768 119.231L742.03 195.571L740.548 196.216L707.286 119.877L708.768 119.231Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M743.129 105.774L776.391 182.114L774.909 182.759L741.647 106.42L743.129 105.774Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M548.473 1000.3L442.473 726.797L587.973 671.297L695.473 944.297L548.473 1000.3Z",
    fill: "#6CDD59",
    stroke: "#9C9C9C",
    strokeWidth: 5
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M536.332 970.246L684.501 914.035L685.254 916.02L537.085 972.231L536.332 970.246Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M674.476 878.542L519.775 939.901L518.992 937.928L673.694 876.569L674.476 878.542Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M661.464 845.299L506.85 906.883L506.065 904.91L660.678 843.326L661.464 845.299Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.123 834.371L631.292 778.16L632.045 780.145L483.876 836.356L483.123 834.371Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M496.226 867.836L644.395 811.625L645.149 813.61L496.979 869.821L496.226 867.836Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M440.466 725.449L588.636 669.238L589.389 671.223L441.219 727.434L440.466 725.449Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M761.973 1308.8L708.473 1171.3L775.473 1145.8L828.973 1283.3L761.973 1308.8Z",
    fill: "#6CDD59",
    stroke: "#9C9C9C",
    strokeWidth: 5
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M638.177 1230.32L786.347 1174.11L787.1 1176.09L638.93 1232.31L638.177 1230.32Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M651.546 1264.46L799.803 1208.47L800.553 1210.46L652.296 1266.44L651.546 1264.46Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M664.651 1297.92L812.908 1241.93L813.658 1243.92L665.401 1299.91L664.651 1297.92Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M626.393 1200.22L774.65 1144.24L775.401 1146.22L627.143 1202.21L626.393 1200.22Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M680.746 1339.02L828.915 1282.81L829.668 1284.79L681.499 1341L680.746 1339.02Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M865.973 1578.8L787.473 1378.3L703.973 1409.8L783.973 1611.3L865.973 1578.8Z",
    fill: "#6CDD59"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M937.886 1551.18L783.185 1612.54L782.403 1610.56L937.104 1549.21L937.886 1551.18Z",
    fill: "#9C9C9C"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M757.702 1535.53L905.959 1479.55L906.709 1481.53L758.452 1537.52L757.702 1535.53Z",
    fill: "#9C9C9C"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M770.806 1569L918.976 1512.78L919.729 1514.77L771.559 1570.98L770.806 1569Z",
    fill: "#9C9C9C"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M732.546 1471.3L880.716 1415.09L881.469 1417.07L733.3 1473.29L732.546 1471.3Z",
    fill: "#9C9C9C"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M746.003 1505.66L894.173 1449.45L894.926 1451.44L746.757 1507.65L746.003 1505.66Z",
    fill: "#9C9C9C"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M720.849 1441.43L869.018 1385.22L869.772 1387.2L721.602 1443.41L720.849 1441.43Z",
    fill: "#9C9C9C"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M858.911 1349.5L704.298 1411.08L703.512 1409.11L858.125 1347.53L858.911 1349.5Z",
    fill: "#9C9C9C"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M229.973 702.297L175.473 562.297L244.973 534.297L302.973 675.297L229.973 702.297Z",
    fill: "#6CDD59",
    stroke: "#9C9C9C",
    strokeWidth: 5
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.622 701.637L303.228 674.625L303.742 676.025L230.135 703.037L229.622 701.637Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.176 659.637L286.783 632.625L287.297 634.025L213.69 661.037L213.176 659.637Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.642 597.016L198.41 627.906L197.85 626.523L274.082 595.634L274.642 597.016Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.715 564.005L185.482 594.894L184.922 593.512L261.154 562.622L261.715 564.005Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M398.973 1133.8L360.473 1039.3L435.473 1013.8L472.973 1107.3L398.973 1133.8Z",
    fill: "#6CDD59",
    stroke: "#9C9C9C",
    strokeWidth: 5
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M398.575 1133.07L472.27 1106.28L472.779 1107.68L399.085 1134.47L398.575 1133.07Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M373.423 1068.84L447.117 1042.05L447.627 1043.45L373.932 1070.24L373.423 1068.84Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.876 1103.2L460.482 1076.19L460.996 1077.59L387.389 1104.6L386.876 1103.2Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M361.723 1038.97L435.33 1011.96L435.843 1013.36L362.237 1040.37L361.723 1038.97Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M767.473 2077.3L727.473 1974.3L801.973 1947.8L840.973 2048.3L767.473 2077.3Z",
    fill: "#6CDD59"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M727.77 1973.7L801.377 1946.69L801.89 1948.09L728.284 1975.1L727.77 1973.7Z",
    fill: "#9C9C9C"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M741.14 2007.83L814.834 1981.05L815.344 1982.45L741.649 2009.24L741.14 2007.83Z",
    fill: "#9C9C9C"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M754.594 2042.2L828.201 2015.19L828.715 2016.59L755.108 2043.6L754.594 2042.2Z",
    fill: "#9C9C9C"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M767.698 2075.66L841.304 2048.65L841.818 2050.05L768.212 2077.06L767.698 2075.66Z",
    fill: "#9C9C9C"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M533.473 1477.3L506.473 1409.3L579.973 1382.8L606.973 1447.3L533.473 1477.3Z",
    fill: "#6CDD59"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M607.709 1447.53L531.476 1478.42L530.916 1477.04L607.149 1446.15L607.709 1447.53Z",
    fill: "#9C9C9C"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M594.779 1414.52L518.547 1445.41L517.987 1444.02L594.219 1413.13L594.779 1414.52Z",
    fill: "#9C9C9C"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M506.135 1407.74L579.742 1380.73L580.256 1382.13L506.649 1409.14L506.135 1407.74Z",
    fill: "#9C9C9C"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M737.973 508.797L699.973 411.297L776.473 381.797L814.973 479.797L737.973 508.797Z",
    fill: "#6CDD59",
    stroke: "#9C9C9C",
    strokeWidth: 5
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M653.582 502.375L801.975 446.076L802.729 448.061L654.335 504.36L653.582 502.375Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M666.687 535.839L815.081 479.541L815.834 481.526L667.44 537.825L666.687 535.839Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M640.973 470.797L628.473 437.797L698.973 411.297L711.473 443.297L640.973 470.797Z",
    fill: "#FF1717",
    stroke: "#9C9C9C",
    strokeWidth: 5
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M627.724 436.347L776.118 380.048L776.871 382.034L628.477 438.332L627.724 436.347Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M640.743 469.584L789.225 413.51L789.975 415.496L641.493 471.571L640.743 469.584Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M411.973 659.797L387.473 591.297L468.973 560.297L495.473 626.797L411.973 659.797Z",
    fill: "#6CDD59",
    stroke: "#9C9C9C",
    strokeWidth: 5
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M565.683 600.73L410.982 662.089L410.199 660.115L564.901 598.756L565.683 600.73Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.258 589.573L535.516 533.586L536.266 535.573L388.009 591.559L387.258 589.573Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M400.362 623.037L548.619 567.051L549.369 569.037L401.112 625.024L400.362 623.037Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M888.973 1871.8L850.973 1770.8L997.473 1715.3L1037.47 1815.3L888.973 1871.8Z",
    fill: "#6CDD59"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M849.17 1769.11L997.339 1712.89L998.092 1714.88L849.923 1771.09L849.17 1769.11Z",
    fill: "#9C9C9C"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M889.273 1871.52L1037.44 1815.31L1038.2 1817.29L890.026 1873.5L889.273 1871.52Z",
    fill: "#9C9C9C"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M473.473 807.297L458.473 768.797L538.473 738.797L552.473 775.797L473.473 807.297Z",
    fill: "#FF1717",
    stroke: "#9C9C9C",
    strokeWidth: 5
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M623.994 749.628L469.293 810.987L468.51 809.014L623.211 747.655L623.994 749.628Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M456.915 767.444L605.172 711.457L605.922 713.444L457.665 769.43L456.915 767.444Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M586.473 1099.3L573.973 1065.8L654.473 1035.8L667.473 1067.8L586.473 1099.3Z",
    fill: "#FF1717",
    stroke: "#9C9C9C",
    strokeWidth: 5
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M573.184 1064.35L721.441 1008.36L722.192 1010.35L573.934 1066.34L573.184 1064.35Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M595.973 1638.3L583.473 1605.3L656.973 1578.8L668.973 1611.3L595.973 1638.3Z",
    fill: "#FF1717"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M583.095 1604.25L656.789 1577.47L657.299 1578.87L583.604 1605.65L583.095 1604.25Z",
    fill: "#9C9C9C"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M335.473 972.797L265.973 794.797L339.473 768.297L409.473 942.797L335.473 972.797Z",
    fill: "#6CDD59",
    stroke: "#9C9C9C",
    strokeWidth: 5
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M410.261 943.333L334.029 974.222L333.469 972.84L409.701 941.951L410.261 943.333Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.512 903.094L382.119 876.082L382.633 877.482L309.026 904.494L308.512 903.094Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321.618 936.555L395.224 909.543L395.738 910.943L322.132 937.955L321.618 936.555Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.793 847.663L296.472 878.327L295.916 876.943L372.236 846.279L372.793 847.663Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.308 836.166L356.002 809.379L356.511 810.781L282.817 837.568L282.308 836.166Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.858 794.168L339.464 767.156L339.978 768.556L266.372 795.568L265.858 794.168Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.694 539.718C187.094 529.117 217.506 517.531 229.376 513.662C235.412 511.695 239.681 511.771 242.579 513.4C245.525 515.056 246.672 518.092 246.994 521.077C247.317 524.068 246.848 527.258 246.323 529.648C246.058 530.854 245.774 531.88 245.556 532.605C245.446 532.969 245.353 533.258 245.287 533.458C245.253 533.558 245.227 533.637 245.208 533.691L245.186 533.754L245.18 533.771L245.177 533.778C245.177 533.779 245.177 533.779 244.005 533.358L245.177 533.779L244.99 534.3L173.948 563.425L173.003 561.121L243.005 532.422C243.053 532.273 243.109 532.094 243.171 531.888C243.375 531.21 243.642 530.247 243.891 529.114C244.392 526.829 244.799 523.945 244.518 521.344C244.237 518.737 243.301 516.663 241.359 515.571C239.369 514.452 235.942 514.142 230.148 516.03C218.358 519.873 188.023 531.428 160.593 542.04C146.887 547.343 133.92 552.404 124.38 556.141C119.61 558.009 115.696 559.545 112.975 560.615C111.615 561.149 110.553 561.568 109.83 561.852L108.838 562.243C108.787 562.276 108.714 562.323 108.622 562.385C108.414 562.525 108.104 562.738 107.712 563.023C106.928 563.595 105.814 564.459 104.512 565.612C101.908 567.919 98.5698 571.376 95.6333 575.966C89.7841 585.108 85.4879 598.799 91.8804 617.066C98.478 635.564 120.799 691.736 141.485 743.321C151.826 769.106 161.754 793.735 169.097 811.917C172.768 821.008 175.793 828.487 177.9 833.694C178.954 836.297 179.778 838.332 180.339 839.716L181.135 841.682C181.164 841.72 181.2 841.766 181.242 841.821C181.379 842 181.585 842.268 181.861 842.619C182.414 843.322 183.244 844.36 184.348 845.692C186.558 848.358 189.868 852.201 194.255 856.9C203.031 866.298 216.115 879.114 233.337 892.765C239.606 897.687 244.674 901.456 248.891 904.591C250.514 905.799 252.012 906.912 253.402 907.961C258.388 911.722 262.024 914.668 265.086 918.103C271.214 924.977 274.935 933.699 283.088 954.517C291.267 975.404 405.827 1268.77 518.342 1556.91C574.599 1700.98 630.345 1843.75 672.027 1950.5L741.321 2127.96C741.325 2127.97 741.326 2127.98 740.167 2128.43L741.326 2127.98L741.406 2128.18L741.411 2128.4L741.411 2128.4L741.411 2128.4L741.412 2128.41C741.413 2128.43 741.414 2128.46 741.417 2128.5C741.422 2128.58 741.431 2128.7 741.448 2128.86C741.484 2129.17 741.55 2129.63 741.676 2130.16C741.93 2131.25 742.413 2132.61 743.319 2133.84C744.212 2135.05 745.528 2136.15 747.513 2136.73C749.515 2137.31 752.292 2137.4 756.133 2136.39C758.05 2135.89 763.637 2133.88 772.049 2130.71C780.422 2127.55 791.515 2123.26 804.383 2118.24C830.116 2108.18 862.932 2095.17 895.251 2082.29C927.569 2069.41 959.389 2056.65 983.129 2047.12C994.999 2042.36 1004.85 2038.4 1011.73 2035.63C1015.17 2034.24 1017.87 2033.16 1019.71 2032.42L1021.38 2031.74L1008.83 1999.68L770.736 2090.85L173.83 563.947L176.149 563.04L772.155 2087.64L1010.25 1996.47L1024.6 2033.13L1023.46 2033.59L1022.99 2032.44C1023.46 2033.59 1023.46 2033.59 1023.46 2033.59L1023.45 2033.6L1020.64 2034.73C1018.8 2035.47 1016.1 2036.55 1012.66 2037.94C1005.78 2040.71 995.927 2044.67 984.057 2049.43C960.315 2058.97 928.494 2071.72 896.173 2084.6C863.852 2097.49 831.03 2110.5 805.289 2120.56C792.418 2125.59 781.315 2129.88 772.928 2133.04C764.579 2136.19 758.84 2138.25 756.764 2138.8C752.617 2139.88 749.365 2139.86 746.816 2139.12C744.251 2138.37 742.495 2136.92 741.314 2135.32C740.146 2133.73 739.554 2132.02 739.252 2130.73C739.099 2130.08 739.017 2129.53 738.973 2129.13C738.954 2128.95 738.941 2128.81 738.934 2128.69L669.707 1951.4C628.026 1844.65 572.279 1701.89 516.022 1557.82C403.507 1269.67 288.948 976.31 280.769 955.425C272.563 934.469 268.994 926.23 263.227 919.76C260.341 916.523 256.877 913.701 251.903 909.949C250.531 908.914 249.045 907.809 247.429 906.608C243.206 903.468 238.095 899.666 231.797 894.723L231.793 894.719C214.458 880.978 201.282 868.074 192.435 858.6C188.012 853.862 184.67 849.982 182.431 847.282C181.312 845.932 180.468 844.877 179.903 844.158C179.621 843.798 179.408 843.522 179.265 843.336C179.193 843.242 179.139 843.171 179.102 843.123L179.061 843.067L179.05 843.053L179.046 843.048C179.046 843.047 179.045 843.047 180.043 842.302C178.889 842.769 178.889 842.769 178.888 842.767L178.031 840.651C177.47 839.267 176.646 837.232 175.592 834.628C173.485 829.421 170.459 821.941 166.788 812.849C159.444 794.666 149.516 770.036 139.174 744.247C118.497 692.686 96.1503 636.452 89.5336 617.899L89.5311 617.892C82.8491 598.801 87.3345 584.316 93.5356 574.623C96.6246 569.795 100.129 566.168 102.861 563.748C104.228 562.536 105.405 561.624 106.245 561.011C106.665 560.705 107.002 560.473 107.236 560.316C107.353 560.238 107.444 560.178 107.508 560.137C107.54 560.117 107.565 560.101 107.583 560.089L107.604 560.076L107.61 560.072L107.612 560.071C107.613 560.07 107.614 560.07 108.27 561.128C107.813 559.97 107.813 559.97 107.814 559.969L108.918 559.535C109.641 559.25 110.703 558.832 112.064 558.297C114.786 557.227 118.7 555.69 123.472 553.822C133.014 550.085 145.984 545.022 159.694 539.718ZM108.27 561.128L107.813 559.97L107.709 560.011L107.614 560.07L108.27 561.128ZM180.043 842.302L178.889 842.769L178.949 842.918L179.046 843.048L180.043 842.302Z",
    fill: "#9C9C9C"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M179.046 843.048C179.046 843.047 179.045 843.047 180.043 842.302M179.046 843.048L178.949 842.918L178.889 842.769L180.043 842.302M179.046 843.048L180.043 842.302M179.046 843.048L179.05 843.053L179.061 843.067L179.102 843.123C179.139 843.171 179.193 843.242 179.265 843.336C179.408 843.522 179.621 843.798 179.903 844.158C180.468 844.877 181.312 845.932 182.431 847.282C184.67 849.982 188.012 853.862 192.435 858.6C201.282 868.074 214.458 880.978 231.793 894.719L231.797 894.723C238.095 899.666 243.206 903.468 247.429 906.608C249.045 907.809 250.531 908.914 251.903 909.949C256.877 913.701 260.341 916.523 263.227 919.76C268.994 926.23 272.563 934.469 280.769 955.425C288.948 976.31 403.507 1269.67 516.022 1557.82C572.279 1701.89 628.026 1844.65 669.707 1951.4L738.934 2128.69C738.941 2128.81 738.954 2128.95 738.973 2129.13C739.017 2129.53 739.099 2130.08 739.252 2130.73C739.554 2132.02 740.146 2133.73 741.314 2135.32C742.495 2136.92 744.251 2138.37 746.816 2139.12C749.365 2139.86 752.617 2139.88 756.764 2138.8C758.84 2138.25 764.579 2136.19 772.928 2133.04C781.315 2129.88 792.418 2125.59 805.289 2120.56C831.03 2110.5 863.852 2097.49 896.173 2084.6C928.494 2071.72 960.315 2058.97 984.057 2049.43C995.927 2044.67 1005.78 2040.71 1012.66 2037.94C1016.1 2036.55 1018.8 2035.47 1020.64 2034.73L1023.45 2033.6L1023.46 2033.59C1023.46 2033.59 1023.46 2033.59 1022.99 2032.44L1023.46 2033.59L1024.6 2033.13L1010.25 1996.47L772.155 2087.64L176.149 563.04L173.83 563.947L770.736 2090.85L1008.83 1999.68L1021.38 2031.74L1019.71 2032.42C1017.87 2033.16 1015.17 2034.24 1011.73 2035.63C1004.85 2038.4 994.999 2042.36 983.129 2047.12C959.389 2056.65 927.569 2069.41 895.251 2082.29C862.932 2095.17 830.116 2108.18 804.383 2118.24C791.515 2123.26 780.422 2127.55 772.049 2130.71C763.637 2133.88 758.05 2135.89 756.133 2136.39C752.292 2137.4 749.515 2137.31 747.513 2136.73C745.528 2136.15 744.212 2135.05 743.319 2133.84C742.413 2132.61 741.93 2131.25 741.676 2130.16C741.55 2129.63 741.484 2129.17 741.448 2128.86C741.431 2128.7 741.422 2128.58 741.417 2128.5C741.414 2128.46 741.413 2128.43 741.412 2128.41L741.411 2128.4L741.411 2128.4L741.411 2128.4L741.406 2128.18L741.326 2127.98L740.167 2128.43C741.326 2127.98 741.325 2127.97 741.321 2127.96L672.027 1950.5C630.345 1843.75 574.599 1700.98 518.342 1556.91C405.827 1268.77 291.267 975.404 283.088 954.517C274.935 933.699 271.214 924.977 265.086 918.103C262.024 914.668 258.388 911.722 253.402 907.961C252.012 906.912 250.514 905.799 248.891 904.591C244.674 901.456 239.606 897.687 233.337 892.765C216.115 879.114 203.031 866.298 194.255 856.9C189.868 852.201 186.558 848.358 184.348 845.692C183.244 844.36 182.414 843.322 181.861 842.619C181.585 842.268 181.379 842 181.242 841.821C181.2 841.766 181.164 841.72 181.135 841.682L180.339 839.716C179.778 838.332 178.954 836.297 177.9 833.694C175.793 828.487 172.768 821.008 169.097 811.917C161.754 793.735 151.826 769.106 141.485 743.321C120.799 691.736 98.478 635.564 91.8804 617.066C85.4879 598.799 89.7841 585.108 95.6333 575.966C98.5698 571.376 101.908 567.919 104.512 565.612C105.814 564.459 106.928 563.595 107.712 563.023C108.104 562.738 108.414 562.525 108.622 562.385C108.714 562.323 108.787 562.276 108.838 562.243L109.83 561.852C110.553 561.568 111.615 561.149 112.975 560.615C115.696 559.545 119.61 558.009 124.38 556.141C133.92 552.404 146.887 547.343 160.593 542.04C188.023 531.428 218.358 519.873 230.148 516.03C235.942 514.142 239.369 514.452 241.359 515.571C243.301 516.663 244.237 518.737 244.518 521.344C244.799 523.945 244.392 526.829 243.891 529.114C243.642 530.247 243.375 531.21 243.171 531.888C243.109 532.094 243.053 532.273 243.005 532.422L173.003 561.121L173.948 563.425L244.99 534.3L245.177 533.779L244.005 533.358C245.177 533.779 245.177 533.779 245.177 533.778L245.18 533.771L245.186 533.754L245.208 533.691C245.227 533.637 245.253 533.558 245.287 533.458C245.353 533.258 245.446 532.969 245.556 532.605C245.774 531.88 246.058 530.854 246.323 529.648C246.848 527.258 247.317 524.068 246.994 521.077C246.672 518.092 245.525 515.056 242.579 513.4C239.681 511.771 235.412 511.695 229.376 513.662C217.506 517.531 187.094 529.117 159.694 539.718C145.984 545.022 133.014 550.085 123.472 553.822C118.7 555.69 114.786 557.227 112.064 558.297C110.703 558.832 109.641 559.25 108.918 559.535L107.814 559.969C107.813 559.97 107.813 559.97 108.27 561.128M180.043 842.302C178.889 842.769 178.889 842.769 178.888 842.767L178.031 840.651C177.47 839.267 176.646 837.232 175.592 834.628C173.485 829.421 170.459 821.941 166.788 812.849C159.444 794.666 149.516 770.036 139.174 744.247C118.497 692.686 96.1503 636.452 89.5336 617.899L89.5311 617.892C82.8491 598.801 87.3345 584.316 93.5356 574.623C96.6246 569.795 100.129 566.168 102.861 563.748C104.228 562.536 105.405 561.624 106.245 561.011C106.665 560.705 107.002 560.473 107.236 560.316C107.353 560.238 107.444 560.178 107.508 560.137C107.54 560.117 107.565 560.101 107.583 560.089L107.604 560.076L107.61 560.072L107.612 560.071C107.613 560.07 107.614 560.07 108.27 561.128M108.27 561.128L107.813 559.97L107.709 560.011L107.614 560.07L108.27 561.128Z",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M876.473 1837.8L864.973 1809.3L943.473 1779.3L954.973 1809.3L876.473 1837.8Z",
    fill: "#FF1717"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M875.819 1837.15L1024.08 1781.17L1024.83 1783.15L876.569 1839.14L875.819 1837.15Z",
    fill: "#9C9C9C"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M864.121 1807.28L1012.29 1751.07L1013.04 1753.06L864.874 1809.27L864.121 1807.28Z",
    fill: "#9C9C9C"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M672.473 223.797L637.473 144.297L670.473 130.797L705.473 210.297L672.473 223.797Z",
    fill: "#FE763B",
    stroke: "#9C9C9C",
    strokeWidth: 5
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M638.922 146.583L672.409 222.834L670.929 223.484L637.442 147.233L638.922 146.583Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M673.283 133.126L706.545 209.465L705.064 210.111L671.801 133.772L673.283 133.126Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1138.28 840.289L1132.18 824.031L1134.25 823.253L1140.35 839.511L1138.28 840.289Z",
    fill: "#9C9C9C"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1124.92 836.857L1137.27 832.02L1138.07 834.056L1125.71 838.893L1124.92 836.857Z",
    fill: "#9C9C9C"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1151.12 873.08L1144.93 856.597L1147 855.819L1153.2 872.302L1151.12 873.08Z",
    fill: "#9C9C9C"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1134.1 864.423L1139.29 877.951L1120.8 885.038L1115.62 871.51L1134.1 864.423ZM1132.84 867.248L1118.44 872.769L1122.06 882.213L1136.46 876.692L1132.84 867.248Z",
    fill: "#9C9C9C"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1137.69 869.417L1150.13 864.804L1150.89 866.854L1138.45 871.467L1137.69 869.417Z",
    fill: "#9C9C9C"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M1172.34 875.93L1092.38 907.24L1102.59 933.292L1182.54 901.982L1172.34 875.93Z",
    fill: "#9C9C9C"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1157.7 843.171L1080.21 873.514L1079.44 871.537L1156.92 841.194L1157.7 843.171Z",
    fill: "#9C9C9C"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1171.88 926.084L1165.69 909.601L1167.76 908.823L1173.95 925.305L1171.88 926.084Z",
    fill: "#9C9C9C"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1154.86 917.431L1160.05 930.959L1141.57 938.045L1136.38 924.518L1154.86 917.431ZM1153.61 920.256L1139.21 925.777L1142.83 935.221L1157.23 929.7L1153.61 920.256Z",
    fill: "#9C9C9C"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1158.44 922.417L1170.89 917.804L1171.65 919.854L1159.21 924.467L1158.44 922.417Z",
    fill: "#9C9C9C"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1184.63 958.65L1178.44 942.167L1180.51 941.389L1186.71 957.872L1184.63 958.65Z",
    fill: "#9C9C9C"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1167.71 950.037L1172.9 963.564L1154.41 970.651L1149.23 957.123L1167.71 950.037ZM1166.45 952.862L1152.05 958.382L1155.67 967.826L1170.07 962.305L1166.45 952.862Z",
    fill: "#9C9C9C"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1171.27 955.213L1183.62 950.375L1184.42 952.411L1172.06 957.249L1171.27 955.213Z",
    fill: "#9C9C9C"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M1205.85 961.5L1125.89 992.81L1136.1 1018.86L1216.05 987.552L1205.85 961.5Z",
    fill: "#9C9C9C"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1191.21 928.741L1113.72 959.084L1112.95 957.107L1190.43 926.764L1191.21 928.741Z",
    fill: "#9C9C9C"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M447.218 154.953C251.454 230.838 51.716 308.539 35.5889 315.889C19.5926 323.179 11.7794 332.513 7.95287 339.965C6.03621 343.697 5.1122 346.972 4.66709 349.304C4.44452 350.47 4.34177 351.399 4.29454 352.032C4.27093 352.348 4.26121 352.59 4.25732 352.75C4.25538 352.83 4.2549 352.89 4.25487 352.928L4.25505 352.969L4.25515 352.977C4.25514 352.976 4.25514 352.976 3.44723 352.994C2.63933 353.012 2.63931 353.011 2.6393 353.01L2.63926 353.008L2.63916 353.003L2.63894 352.986C2.63879 352.972 2.63866 352.952 2.63867 352.927C2.63871 352.876 2.63934 352.804 2.6416 352.711C2.64611 352.525 2.65711 352.256 2.68282 351.912C2.73424 351.223 2.84452 350.232 3.07956 349.001C3.54963 346.538 4.51902 343.114 6.51516 339.227C10.5142 331.439 18.6044 321.853 34.9187 314.418C51.1023 307.043 250.919 229.312 446.633 153.446C544.503 115.508 641.363 78.0302 713.755 50.037C749.952 36.0404 780.031 24.415 801.061 16.2886C811.577 12.2254 819.83 9.03706 825.454 6.86446L834.064 3.53844C834.07 3.5362 834.073 3.53506 834.364 4.28891C834.233 3.49159 834.233 3.49151 834.234 3.49139L834.236 3.49107L834.242 3.48999L834.266 3.48629C834.286 3.48311 834.315 3.47859 834.353 3.4729C834.429 3.46154 834.539 3.44547 834.684 3.42605C834.972 3.38725 835.393 3.33514 835.932 3.28071C837.011 3.17181 838.563 3.05349 840.47 3.01384C844.282 2.93453 849.523 3.1691 855.235 4.42818C866.671 6.94854 880.04 13.5906 887.538 30.0436C894.913 46.2261 970.762 239.914 1044.75 429.502C1081.74 524.308 1118.28 618.104 1145.57 688.199C1159.21 723.246 1170.54 752.368 1178.46 772.728C1182.42 782.908 1185.53 790.898 1187.65 796.342L1190.89 804.678C1190.89 804.68 1190.89 804.681 1190.87 804.69L1190.89 804.682L1630.14 1915.74L1630.15 1915.84L1629.35 1915.95C1630.15 1915.84 1630.15 1915.84 1630.15 1915.84L1630.15 1915.84L1630.16 1915.89L1630.18 1916.04C1630.19 1916.17 1630.22 1916.36 1630.25 1916.61C1630.31 1917.1 1630.39 1917.82 1630.48 1918.72C1630.65 1920.51 1630.84 1923.02 1630.9 1925.9C1631.03 1931.64 1630.67 1938.91 1628.67 1944.85C1626.67 1950.79 1622.93 1955.62 1616.2 1955.91C1609.62 1956.2 1600.47 1952.11 1587.71 1941.22L1587.55 1941.08L922.874 233.189L839.822 269.857L774.36 92.1074L90.2395 351.484L127.423 446.435L112.568 494.97L111.023 494.497L125.713 446.5L88.1388 350.552L775.312 90.0177L840.744 267.684L923.767 231.028L1588.91 1940.12C1601.55 1950.87 1610.24 1954.55 1616.12 1954.29C1621.88 1954.04 1625.23 1949.99 1627.14 1944.33C1629.05 1938.67 1629.41 1931.62 1629.28 1925.94C1629.22 1923.11 1629.04 1920.64 1628.87 1918.87C1628.79 1917.99 1628.7 1917.29 1628.65 1916.8C1628.62 1916.56 1628.59 1916.38 1628.58 1916.25L1628.56 1916.16L1189.39 805.276L1189.39 805.272L1190.14 804.981C1189.39 805.272 1189.39 805.269 1189.39 805.264L1186.14 796.928C1184.68 793.168 1182.75 788.195 1180.39 782.125L1176.96 773.314C1169.04 752.954 1157.71 723.832 1144.06 688.785C1116.77 618.69 1080.24 524.895 1043.24 430.089C969.238 240.455 893.418 46.8421 886.068 30.7139C878.841 14.8563 865.99 8.45339 854.888 6.00649C849.331 4.78192 844.224 4.55228 840.504 4.62967C838.645 4.66835 837.136 4.78361 836.095 4.88872C835.574 4.94127 835.171 4.99126 834.899 5.02781C834.763 5.04609 834.661 5.061 834.593 5.07118L834.574 5.07399L826.036 8.37208C820.412 10.5447 812.159 13.733 801.644 17.7962C780.614 25.9225 750.535 37.5479 714.338 51.5445C641.946 79.5376 545.087 117.015 447.218 154.953ZM834.364 4.28891L834.233 3.49159L834.151 3.50511L834.073 3.53506L834.364 4.28891Z",
    fill: "#9C9C9C"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M834.364 4.28891C834.073 3.53506 834.07 3.5362 834.064 3.53844L825.454 6.86446C819.83 9.03706 811.577 12.2254 801.061 16.2886C780.031 24.415 749.952 36.0404 713.755 50.037C641.363 78.0302 544.503 115.508 446.633 153.446C250.919 229.312 51.1023 307.043 34.9187 314.418C18.6044 321.853 10.5142 331.439 6.51516 339.227C4.51902 343.114 3.54963 346.538 3.07956 349.001C2.84452 350.232 2.73424 351.223 2.68282 351.912C2.65711 352.256 2.64611 352.525 2.6416 352.711C2.63934 352.804 2.63871 352.876 2.63867 352.927C2.63866 352.952 2.63879 352.972 2.63894 352.986L2.63916 353.003L2.63926 353.008L2.6393 353.01C2.63931 353.011 2.63933 353.012 3.44723 352.994C4.25514 352.976 4.25514 352.976 4.25515 352.977L4.25505 352.969L4.25487 352.928C4.2549 352.89 4.25538 352.83 4.25732 352.75C4.26121 352.59 4.27093 352.348 4.29454 352.032C4.34177 351.399 4.44452 350.47 4.66709 349.304C5.1122 346.972 6.03621 343.697 7.95287 339.965C11.7794 332.513 19.5926 323.179 35.5889 315.889C51.716 308.539 251.454 230.838 447.218 154.953C545.087 117.015 641.946 79.5376 714.338 51.5445C750.535 37.5479 780.614 25.9225 801.644 17.7962C812.159 13.733 820.412 10.5447 826.036 8.37208L834.574 5.07399L834.593 5.07118C834.661 5.061 834.763 5.04609 834.899 5.02781C835.171 4.99126 835.574 4.94127 836.095 4.88872C837.136 4.78361 838.645 4.66835 840.504 4.62967C844.224 4.55228 849.331 4.78192 854.888 6.00649C865.99 8.45339 878.841 14.8563 886.068 30.7139C893.418 46.8421 969.238 240.455 1043.24 430.089C1080.24 524.895 1116.77 618.69 1144.06 688.785C1157.71 723.832 1169.04 752.954 1176.96 773.314L1180.39 782.125C1182.75 788.195 1184.68 793.168 1186.14 796.928L1189.39 805.264C1189.39 805.269 1189.39 805.272 1190.14 804.981L1189.39 805.272L1189.39 805.276L1628.56 1916.16L1628.58 1916.25C1628.59 1916.38 1628.62 1916.56 1628.65 1916.8C1628.7 1917.29 1628.79 1917.99 1628.87 1918.87C1629.04 1920.64 1629.22 1923.11 1629.28 1925.94C1629.41 1931.62 1629.05 1938.67 1627.14 1944.33C1625.23 1949.99 1621.88 1954.04 1616.12 1954.29C1610.24 1954.55 1601.55 1950.87 1588.91 1940.12L923.767 231.028L840.744 267.684L775.312 90.0177L88.1388 350.552L125.713 446.5L111.023 494.497L112.568 494.97L127.423 446.435L90.2395 351.484L774.36 92.1074L839.822 269.857L922.874 233.189L1587.55 1941.08L1587.71 1941.22C1600.47 1952.11 1609.62 1956.2 1616.2 1955.91C1622.93 1955.62 1626.67 1950.79 1628.67 1944.85C1630.67 1938.91 1631.03 1931.64 1630.9 1925.9C1630.84 1923.02 1630.65 1920.51 1630.48 1918.72C1630.39 1917.82 1630.31 1917.1 1630.25 1916.61C1630.22 1916.36 1630.19 1916.17 1630.18 1916.04L1630.16 1915.89L1630.15 1915.84L1630.15 1915.84C1630.15 1915.84 1630.15 1915.84 1629.35 1915.95L1630.15 1915.84L1630.14 1915.74L1190.89 804.682L1190.87 804.69C1190.89 804.681 1190.89 804.68 1190.89 804.678L1187.65 796.342C1185.53 790.898 1182.42 782.908 1178.46 772.728C1170.54 752.368 1159.21 723.246 1145.57 688.199C1118.28 618.104 1081.74 524.308 1044.75 429.502C970.762 239.914 894.913 46.2261 887.538 30.0436C880.04 13.5906 866.671 6.94854 855.235 4.42818C849.523 3.1691 844.282 2.93453 840.47 3.01384C838.563 3.05349 837.011 3.17181 835.932 3.28071C835.393 3.33514 834.972 3.38725 834.684 3.42605C834.539 3.44547 834.429 3.46154 834.353 3.4729C834.315 3.47859 834.286 3.48311 834.266 3.48629L834.242 3.48999L834.236 3.49107L834.234 3.49139C834.233 3.49151 834.233 3.49159 834.364 4.28891ZM834.364 4.28891L834.233 3.49159L834.151 3.50511L834.073 3.53506L834.364 4.28891ZM1138.28 840.289L1132.18 824.031L1134.25 823.253L1140.35 839.511L1138.28 840.289ZM1124.92 836.857L1137.27 832.02L1138.07 834.056L1125.71 838.893L1124.92 836.857ZM1151.12 873.08L1144.93 856.597L1147 855.819L1153.2 872.302L1151.12 873.08ZM1134.1 864.423L1139.29 877.951L1120.8 885.038L1115.62 871.51L1134.1 864.423ZM1132.84 867.248L1118.44 872.769L1122.06 882.213L1136.46 876.692L1132.84 867.248ZM1137.69 869.417L1150.13 864.804L1150.89 866.854L1138.45 871.467L1137.69 869.417ZM1172.34 875.93L1092.38 907.24L1102.59 933.292L1182.54 901.982L1172.34 875.93ZM1157.7 843.171L1080.21 873.514L1079.44 871.537L1156.92 841.194L1157.7 843.171ZM1171.88 926.084L1165.69 909.601L1167.76 908.823L1173.95 925.305L1171.88 926.084ZM1154.86 917.431L1160.05 930.959L1141.57 938.045L1136.38 924.518L1154.86 917.431ZM1153.61 920.256L1139.21 925.777L1142.83 935.221L1157.23 929.7L1153.61 920.256ZM1158.44 922.417L1170.89 917.804L1171.65 919.854L1159.21 924.467L1158.44 922.417ZM1184.63 958.65L1178.44 942.167L1180.51 941.389L1186.71 957.872L1184.63 958.65ZM1167.71 950.037L1172.9 963.564L1154.41 970.651L1149.23 957.123L1167.71 950.037ZM1166.45 952.862L1152.05 958.382L1155.67 967.826L1170.07 962.305L1166.45 952.862ZM1171.27 955.213L1183.62 950.375L1184.42 952.411L1172.06 957.249L1171.27 955.213ZM1205.85 961.5L1125.89 992.81L1136.1 1018.86L1216.05 987.552L1205.85 961.5ZM1191.21 928.741L1113.72 959.084L1112.95 957.107L1190.43 926.764L1191.21 928.741Z",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M718.973 670.297L677.973 574.297L829.473 513.797L867.973 614.797L718.973 670.297Z",
    fill: "#6CDD59",
    stroke: "#9C9C9C",
    strokeWidth: 5
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M706.791 638.253L855.184 581.955L855.938 583.94L707.544 640.239L706.791 638.253Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M718.928 669.244L867.41 613.17L868.16 615.157L719.678 671.231L718.928 669.244Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M844.852 546.318L690.239 607.902L689.453 605.93L844.067 544.346L844.852 546.318Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M831.923 513.307L677.309 574.89L676.524 572.918L831.137 511.334L831.923 513.307Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1342.81 2066.9L678.634 361.601L680.614 360.832L1344.79 2066.13L1342.81 2066.9Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M635.973 1739.8L596.973 1638.8L669.473 1612.8L709.473 1713.3L635.973 1739.8Z",
    fill: "#6CDD59"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M697.853 1677.74L621.533 1708.4L620.977 1707.02L697.297 1676.35L697.853 1677.74Z",
    fill: "#9C9C9C"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M686.683 1649.21L610.363 1679.88L609.807 1678.49L686.127 1647.83L686.683 1649.21Z",
    fill: "#9C9C9C"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M596.196 1637.72L669.802 1610.71L670.316 1612.11L596.71 1639.12L596.196 1637.72Z",
    fill: "#9C9C9C"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M611.973 1167.3L586.973 1099.3L666.473 1068.8L692.473 1135.3L611.973 1167.3Z",
    fill: "#6CDD59",
    stroke: "#9C9C9C",
    strokeWidth: 5
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M764.54 1108.52L609.927 1170.11L609.141 1168.13L763.754 1106.55L764.54 1108.52Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M753.367 1080L598.666 1141.36L597.883 1139.38L752.584 1078.03L753.367 1080Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M586.288 1097.81L734.545 1041.83L735.295 1043.81L587.038 1099.8L586.288 1097.81Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M981.641 1879.48L429.119 459.308L431.098 458.538L983.62 1878.71L981.641 1879.48Z",
    fill: "#9C9C9C",
    stroke: "#9C9C9C",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 755.078,
    y: 2168.58,
    width: 454.149,
    height: 118,
    rx: 10,
    transform: "rotate(-20.9769 755.078 2168.58)",
    fill: "#FE763B"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M869.726 2200.93L860.754 2177.11L867.221 2174.68L874.23 2193.29L883.861 2189.66L885.824 2194.87L869.726 2200.93Z",
    fill: "white"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M897.261 2190.94C895.322 2191.67 893.518 2191.91 891.849 2191.66C890.176 2191.4 888.712 2190.72 887.456 2189.62C886.196 2188.51 885.222 2187.04 884.533 2185.21C883.843 2183.38 883.607 2181.64 883.824 2179.98C884.038 2178.31 884.69 2176.84 885.782 2175.55C886.87 2174.25 888.383 2173.24 890.322 2172.51C892.26 2171.78 894.066 2171.54 895.738 2171.8C897.407 2172.05 898.872 2172.73 900.131 2173.84C901.388 2174.94 902.361 2176.41 903.05 2178.24C903.739 2180.07 903.977 2181.81 903.763 2183.48C903.546 2185.14 902.893 2186.61 901.805 2187.91C900.714 2189.2 899.199 2190.21 897.261 2190.94ZM895.52 2186.17C896.063 2185.97 896.463 2185.61 896.721 2185.1C896.98 2184.58 897.09 2183.95 897.053 2183.19C897.016 2182.43 896.823 2181.59 896.472 2180.66C896.119 2179.72 895.708 2178.96 895.24 2178.38C894.768 2177.78 894.267 2177.38 893.734 2177.16C893.201 2176.95 892.663 2176.94 892.12 2177.15C891.547 2177.36 891.123 2177.73 890.849 2178.25C890.575 2178.77 890.457 2179.41 890.494 2180.16C890.528 2180.91 890.722 2181.75 891.075 2182.69C891.426 2183.62 891.836 2184.39 892.308 2184.98C892.779 2185.57 893.289 2185.97 893.837 2186.18C894.385 2186.39 894.946 2186.39 895.52 2186.17Z",
    fill: "white"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M912.928 2164.26L914.68 2168.92L902.909 2173.35L901.157 2168.7L912.928 2164.26ZM901.824 2163.56L908.245 2161.14L914.422 2177.54C914.515 2177.79 914.637 2177.98 914.786 2178.12C914.933 2178.25 915.111 2178.32 915.322 2178.34C915.529 2178.35 915.773 2178.31 916.052 2178.2C916.246 2178.13 916.462 2178.02 916.7 2177.88C916.946 2177.73 917.126 2177.62 917.238 2177.54L919.868 2181.7C919.613 2181.9 919.242 2182.16 918.754 2182.48C918.273 2182.8 917.676 2183.12 916.961 2183.44C915.517 2184.07 914.223 2184.38 913.08 2184.38C911.934 2184.37 910.952 2184.04 910.136 2183.4C909.319 2182.76 908.684 2181.82 908.229 2180.56L901.824 2163.56Z",
    fill: "white"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M928.709 2178.72L919.737 2154.9L930.066 2151.01C931.88 2150.32 933.496 2150 934.913 2150.02C936.337 2150.04 937.532 2150.38 938.496 2151.03C939.467 2151.69 940.181 2152.62 940.637 2153.83C940.967 2154.7 941.074 2155.57 940.957 2156.44C940.849 2157.31 940.542 2158.11 940.036 2158.86C939.527 2159.6 938.846 2160.24 937.993 2160.77L938.081 2161.01C939.119 2160.66 940.147 2160.57 941.166 2160.73C942.181 2160.89 943.095 2161.29 943.907 2161.95C944.715 2162.59 945.332 2163.47 945.755 2164.6C946.246 2165.9 946.341 2167.19 946.041 2168.46C945.749 2169.73 945.089 2170.89 944.059 2171.94C943.03 2172.99 941.65 2173.85 939.921 2174.5L928.709 2178.72ZM933.231 2171.12L936.255 2169.98C937.34 2169.57 938.079 2169.06 938.47 2168.46C938.858 2167.84 938.901 2167.13 938.6 2166.33C938.39 2165.78 938.084 2165.35 937.682 2165.06C937.28 2164.77 936.805 2164.61 936.256 2164.59C935.715 2164.56 935.114 2164.67 934.455 2164.92L931.338 2166.09L933.231 2171.12ZM929.831 2162.09L932.483 2161.09C933.049 2160.88 933.516 2160.6 933.883 2160.26C934.25 2159.92 934.491 2159.54 934.606 2159.11C934.725 2158.68 934.693 2158.22 934.509 2157.73C934.232 2156.99 933.756 2156.53 933.083 2156.34C932.407 2156.14 931.665 2156.2 930.859 2156.5L928.114 2157.53L929.831 2162.09Z",
    fill: "white"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M957.112 2168.02L948.141 2144.2L958.423 2140.33C960.191 2139.66 961.869 2139.43 963.458 2139.63C965.047 2139.83 966.448 2140.42 967.66 2141.4C968.873 2142.39 969.798 2143.73 970.434 2145.42C971.077 2147.13 971.253 2148.75 970.964 2150.28C970.682 2151.81 969.985 2153.17 968.875 2154.36C967.772 2155.55 966.313 2156.48 964.498 2157.17L958.357 2159.48L956.465 2154.45L961.303 2152.63C962.063 2152.34 962.661 2151.97 963.097 2151.5C963.537 2151.03 963.808 2150.49 963.908 2149.88C964.015 2149.28 963.942 2148.64 963.688 2147.96C963.431 2147.28 963.065 2146.75 962.589 2146.38C962.118 2146 961.563 2145.79 960.924 2145.73C960.29 2145.67 959.593 2145.78 958.833 2146.07L956.553 2146.93L963.579 2165.59L957.112 2168.02Z",
    fill: "white"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M978.7 2159.89L971.972 2142.03L978.206 2139.68L979.485 2143.07L979.671 2143C979.524 2141.62 979.693 2140.51 980.18 2139.66C980.674 2138.81 981.398 2138.21 982.352 2137.85C982.631 2137.75 982.915 2137.66 983.204 2137.61C983.498 2137.54 983.788 2137.5 984.073 2137.48L986.136 2142.96C985.777 2142.97 985.355 2143.04 984.869 2143.16C984.383 2143.28 983.974 2143.4 983.64 2143.53C983.012 2143.76 982.5 2144.12 982.104 2144.6C981.713 2145.06 981.471 2145.61 981.376 2146.23C981.279 2146.84 981.359 2147.49 981.616 2148.17L985.121 2157.47L978.7 2159.89Z",
    fill: "white"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M1000.56 2152.03C998.654 2152.75 996.873 2153 995.219 2152.79C993.569 2152.57 992.113 2151.92 990.852 2150.83C989.595 2149.72 988.605 2148.21 987.88 2146.29C987.185 2144.44 986.95 2142.69 987.175 2141.03C987.399 2139.37 988.045 2137.9 989.113 2136.62C990.181 2135.34 991.638 2134.35 993.483 2133.66C994.833 2133.15 996.133 2132.9 997.384 2132.91C998.635 2132.91 999.799 2133.17 1000.87 2133.68C1001.95 2134.18 1002.91 2134.91 1003.75 2135.89C1004.6 2136.86 1005.29 2138.06 1005.82 2139.48L1006.38 2140.97L990.424 2146.98L989.093 2143.44L999.142 2139.65C998.942 2139.15 998.64 2138.75 998.238 2138.45C997.841 2138.15 997.389 2137.97 996.88 2137.92C996.377 2137.85 995.858 2137.92 995.323 2138.12C994.803 2138.31 994.369 2138.61 994.019 2138.99C993.667 2139.38 993.432 2139.81 993.314 2140.3C993.204 2140.78 993.239 2141.28 993.419 2141.81L994.856 2145.63C995.072 2146.2 995.385 2146.67 995.795 2147.02C996.205 2147.38 996.683 2147.61 997.229 2147.69C997.775 2147.78 998.366 2147.7 999.002 2147.46C999.444 2147.3 999.824 2147.08 1000.14 2146.82C1000.47 2146.56 1000.72 2146.26 1000.89 2145.93C1001.07 2145.59 1001.15 2145.23 1001.15 2144.85L1007.01 2142.64C1007.28 2143.96 1007.21 2145.21 1006.8 2146.41C1006.39 2147.6 1005.66 2148.68 1004.61 2149.66C1003.56 2150.62 1002.21 2151.41 1000.56 2152.03Z",
    fill: "white"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.78 2125.53L1017.53 2130.18L1005.57 2134.68L1003.82 2130.03L1015.78 2125.53ZM1012.83 2147.04L1005.91 2128.66C1005.35 2127.19 1005.16 2125.87 1005.32 2124.7C1005.48 2123.53 1005.95 2122.52 1006.73 2121.68C1007.51 2120.84 1008.56 2120.17 1009.86 2119.68C1010.67 2119.37 1011.49 2119.14 1012.3 2118.97C1013.12 2118.81 1013.74 2118.7 1014.15 2118.65L1014.95 2123.61C1014.69 2123.63 1014.4 2123.67 1014.07 2123.75C1013.75 2123.82 1013.47 2123.9 1013.23 2123.99C1012.63 2124.22 1012.27 2124.5 1012.16 2124.83C1012.04 2125.17 1012.07 2125.54 1012.22 2125.96L1019.25 2144.62L1012.83 2147.04Z",
    fill: "white"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.12 2139.77C1031.22 2140.48 1029.44 2140.74 1027.78 2140.53C1026.13 2140.31 1024.68 2139.65 1023.41 2138.56C1022.16 2137.46 1021.17 2135.95 1020.44 2134.02C1019.75 2132.18 1019.51 2130.42 1019.74 2128.76C1019.96 2127.1 1020.61 2125.63 1021.68 2124.36C1022.74 2123.08 1024.2 2122.09 1026.05 2121.39C1027.39 2120.89 1028.69 2120.64 1029.95 2120.64C1031.2 2120.65 1032.36 2120.91 1033.44 2121.41C1034.51 2121.91 1035.47 2122.65 1036.31 2123.62C1037.16 2124.6 1037.85 2125.79 1038.38 2127.21L1038.94 2128.7L1022.99 2134.71L1021.65 2131.18L1031.7 2127.39C1031.5 2126.88 1031.2 2126.48 1030.8 2126.19C1030.4 2125.89 1029.95 2125.71 1029.44 2125.65C1028.94 2125.59 1028.42 2125.65 1027.88 2125.85C1027.37 2126.05 1026.93 2126.34 1026.58 2126.73C1026.23 2127.11 1025.99 2127.55 1025.88 2128.03C1025.77 2128.52 1025.8 2129.02 1025.98 2129.55L1027.42 2133.36C1027.63 2133.94 1027.95 2134.4 1028.36 2134.76C1028.77 2135.12 1029.24 2135.34 1029.79 2135.43C1030.34 2135.52 1030.93 2135.44 1031.56 2135.2C1032.01 2135.03 1032.39 2134.82 1032.7 2134.56C1033.03 2134.29 1033.28 2134 1033.46 2133.66C1033.63 2133.32 1033.71 2132.96 1033.71 2132.58L1039.58 2130.38C1039.84 2131.69 1039.77 2132.95 1039.36 2134.15C1038.95 2135.34 1038.22 2136.42 1037.17 2137.39C1036.12 2138.35 1034.78 2139.14 1033.12 2139.77Z",
    fill: "white"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M1044.37 2135.16L1037.64 2117.29L1043.87 2114.95L1045.15 2118.34L1045.34 2118.27C1045.19 2116.89 1045.36 2115.78 1045.85 2114.93C1046.34 2114.08 1047.07 2113.48 1048.02 2113.12C1048.3 2113.01 1048.58 2112.93 1048.87 2112.88C1049.17 2112.81 1049.46 2112.77 1049.74 2112.75L1051.8 2118.23C1051.45 2118.24 1051.02 2118.3 1050.54 2118.43C1050.05 2118.55 1049.64 2118.67 1049.31 2118.8C1048.68 2119.03 1048.17 2119.39 1047.77 2119.87C1047.38 2120.33 1047.14 2120.87 1047.04 2121.49C1046.95 2122.11 1047.03 2122.75 1047.28 2123.44L1050.79 2132.74L1044.37 2135.16Z",
    fill: "white"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.57 2129.81L1051.84 2111.94L1058.08 2109.6L1059.36 2112.99L1059.54 2112.92C1059.39 2111.54 1059.56 2110.43 1060.05 2109.58C1060.54 2108.73 1061.27 2108.13 1062.22 2107.77C1062.5 2107.66 1062.79 2107.58 1063.07 2107.53C1063.37 2107.46 1063.66 2107.42 1063.94 2107.4L1066.01 2112.88C1065.65 2112.89 1065.22 2112.96 1064.74 2113.08C1064.25 2113.2 1063.84 2113.32 1063.51 2113.45C1062.88 2113.68 1062.37 2114.04 1061.97 2114.52C1061.58 2114.98 1061.34 2115.53 1061.25 2116.15C1061.15 2116.76 1061.23 2117.4 1061.49 2118.09L1064.99 2127.39L1058.57 2129.81Z",
    fill: "white"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M1080.43 2121.95C1078.52 2122.67 1076.74 2122.92 1075.09 2122.71C1073.44 2122.49 1071.98 2121.84 1070.72 2120.74C1069.46 2119.64 1068.47 2118.13 1067.75 2116.21C1067.06 2114.36 1066.82 2112.61 1067.04 2110.95C1067.27 2109.29 1067.92 2107.82 1068.98 2106.54C1070.05 2105.26 1071.51 2104.27 1073.35 2103.58C1074.7 2103.07 1076 2102.82 1077.25 2102.83C1078.5 2102.83 1079.67 2103.09 1080.74 2103.6C1081.82 2104.09 1082.78 2104.83 1083.62 2105.81C1084.47 2106.78 1085.16 2107.98 1085.69 2109.4L1086.25 2110.88L1070.29 2116.89L1068.96 2113.36L1079.01 2109.57C1078.81 2109.07 1078.51 2108.67 1078.11 2108.37C1077.71 2108.07 1077.26 2107.89 1076.75 2107.84C1076.25 2107.77 1075.73 2107.84 1075.19 2108.04C1074.67 2108.23 1074.24 2108.53 1073.89 2108.91C1073.54 2109.29 1073.3 2109.73 1073.18 2110.22C1073.07 2110.7 1073.11 2111.2 1073.29 2111.73L1074.73 2115.54C1074.94 2116.12 1075.26 2116.58 1075.66 2116.94C1076.07 2117.3 1076.55 2117.53 1077.1 2117.61C1077.64 2117.7 1078.24 2117.62 1078.87 2117.38C1079.31 2117.22 1079.69 2117 1080.01 2116.74C1080.34 2116.48 1080.59 2116.18 1080.76 2115.85C1080.94 2115.51 1081.02 2115.15 1081.02 2114.77L1086.88 2112.56C1087.15 2113.88 1087.08 2115.13 1086.67 2116.33C1086.26 2117.52 1085.53 2118.6 1084.48 2119.57C1083.43 2120.54 1082.08 2121.33 1080.43 2121.95Z",
    fill: "white"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M1098.23 2115.14C1096.96 2115.62 1095.66 2115.73 1094.34 2115.46C1093.03 2115.19 1091.79 2114.5 1090.64 2113.39C1089.49 2112.27 1088.53 2110.68 1087.75 2108.62C1086.94 2106.46 1086.61 2104.59 1086.77 2102.99C1086.94 2101.38 1087.44 2100.07 1088.26 2099.04C1089.1 2098.01 1090.1 2097.27 1091.28 2096.83C1092.16 2096.49 1093 2096.36 1093.78 2096.41C1094.56 2096.47 1095.27 2096.66 1095.92 2097.01C1096.56 2097.34 1097.11 2097.77 1097.57 2098.28L1097.66 2098.25L1094.24 2089.18L1100.66 2086.76L1109.63 2110.58L1103.26 2112.98L1102.16 2110.05L1102.02 2110.1C1102 2110.8 1101.84 2111.48 1101.56 2112.13C1101.28 2112.78 1100.86 2113.36 1100.31 2113.89C1099.76 2114.41 1099.07 2114.82 1098.23 2115.14ZM1098.75 2109.31C1099.34 2109.09 1099.78 2108.73 1100.07 2108.23C1100.36 2107.72 1100.5 2107.11 1100.49 2106.4C1100.48 2105.68 1100.32 2104.88 1099.99 2104.01C1099.66 2103.13 1099.26 2102.41 1098.79 2101.87C1098.32 2101.32 1097.81 2100.96 1097.26 2100.79C1096.71 2100.6 1096.15 2100.62 1095.56 2100.85C1094.97 2101.07 1094.53 2101.43 1094.24 2101.93C1093.95 2102.42 1093.82 2103.02 1093.83 2103.74C1093.85 2104.45 1094.03 2105.25 1094.36 2106.13C1094.69 2107.02 1095.09 2107.73 1095.54 2108.29C1096.01 2108.83 1096.51 2109.2 1097.05 2109.38C1097.59 2109.56 1098.16 2109.54 1098.75 2109.31Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLotB);
export default __webpack_public_path__ + "static/media/LotB.9aaa0a8cfb91ac254f914080b001248a.svg";
export { ForwardRef as ReactComponent };